export const TYPE_OF_HOUSING = [
  'casa',
  'departamento',
];

export const CIVIL_STATUS = [
  'Casado/a',
  'Soltero/a',
  'Divorciado/a',
  'Viudo/a',
  'Conviviente Civil',
];

export const BANK_LIST = [
  'Banco Bice',
  'Banco Consorcio',
  'Banco Corpbanca',
  'Banco de Chile / Edwards-citi',
  'Banco De Crédito Inversiones - Bci',
  'Banco Del Desarrollo',
  'Banco Estado',
  'Banco Falabella',
  'Banco Itaú',
  'Banco Paris',
  'Banco Ripley',
  'Banco Santander',
  'Banco Santander Banefe',
  'Banco Security',
  'Coopeuch',
  'Hsbc Bank Chile',
  'Rabobank',
  'Scotiabank',
];

export const REGIONS = [
  {
    region: 'Región Metropolitana',
    comunas: [
      'Cerrillos',
      'Cerro Navia',
      'Conchalí',
      'El Bosque',
      'Estación Central',
      'Huechuraba',
      'Independencia',
      'La Cisterna',
      'La Florida',
      'La Granja',
      'La Pintana',
      'La Reina',
      'Las Condes',
      'Lo Barnechea',
      'Lo Espejo',
      'Lo Prado',
      'Macul',
      'Maipú',
      'Ñuñoa',
      'Pedro Aguirre Cerda',
      'Peñalolén',
      'Providencia',
      'Pudahuel',
      'Quilicura',
      'Quinta Normal',
      'Recoleta',
      'Renca',
      'Santiago',
      'San Joaquín',
      'San Miguel',
      'San Ramón',
      'Vitacura',
      'Puente Alto',
      'Pirque',
      'San José de Maipo',
      'Colina',
      'Lampa',
      'Tiltil',
      'San Bernardo',
      'Buin',
      'Calera de Tango',
      'Paine',
      'Melipilla',
      'Alhué',
      'Curacaví',
      'María Pinto',
      'San Pedro',
      'Talagante',
      'El Monte',
      'Isla de Maipo',
      'Padre Hurtado',
      'Peñaflor'
    ]
  },
  {
    region: 'Tarapacá',
    comunas: [
      'Iquique',
      'Alto Hospicio',
      'Pozo Almonte',
      'Camiña',
      'Colchane',
      'Huara',
      'Pica'
    ]
  },
  {
    region: 'Antofagasta',
    comunas: [
      'Antofagasta',
      'Mejillones',
      'Sierra Gorda',
      'Taltal',
      'Calama',
      'Ollagüe',
      'San Pedro de Atacama',
      'Tocopilla',
      'María Elena'
    ]
  },
  {
    region: 'Atacama',
    comunas: [
      'Copiapó',
      'Caldera',
      'Tierra Amarilla',
      'Chañaral',
      'Diego de Almagro',
      'Vallenar',
      'Alto del Carmen',
      'Freirina',
      'Huasco'
    ]
  },
  {
    region: 'Coquimbo',
    comunas: [
      'La Serena',
      'Coquimbo',
      'Andacollo',
      'La Higuera',
      'Paiguano',
      'Vicuña',
      'Illapel',
      'Canela',
      'Los Vilos',
      'Salamanca',
      'Ovalle',
      'Combarbalá',
      'Monte Patria',
      'Punitaqui',
      'Río Hurtado'
    ]
  },
  {
    region: 'Valparaíso',
    comunas: [
      'Valparaíso',
      'Casablanca',
      'Concón',
      'Juan Fernández',
      'Puchuncaví',
      'Quintero',
      'Viña del Mar',
      'Isla de Pascua',
      'Los Andes',
      'Calle Larga',
      'Rinconada',
      'San Esteban',
      'La Ligua',
      'Cabildo',
      'Papudo',
      'Petorca',
      'Zapallar',
      'Quillota',
      'Calera',
      'Hijuelas',
      'La Cruz',
      'Nogales',
      'San Antonio',
      'Algarrobo',
      'Cartagena',
      'El Quisco',
      'El Tabo',
      'Santo Domingo',
      'San Felipe',
      'Catemu',
      'Llaillay',
      'Panquehue',
      'Putaendo',
      'Santa María',
      'Quilpué',
      'Limache',
      'Olmué',
      'Villa Alemana'
    ]
  },
  {
    region: 'Región del Libertador Gral. Bernardo O’Higgins',
    comunas: [
      'Rancagua',
      'Codegua',
      'Coinco',
      'Coltauco',
      'Doñihue',
      'Graneros',
      'Las Cabras',
      'Machalí',
      'Malloa',
      'San Francisco de Mostazal',
      'Olivar',
      'Peumo',
      'Pichidegua',
      'Quinta de Tilcoco',
      'Rengo',
      'Requínoa',
      'San Vicente de Tagua Tagua',
      'Pichilemu',
      'La Estrella',
      'Litueche',
      'Marchihue',
      'Navidad',
      'Paredones',
      'San Fernando',
      'Chépica',
      'Chimbarongo',
      'Lolol',
      'Nancagua',
      'Palmilla',
      'Peralillo',
      'Placilla',
      'Pumanque',
      'Santa Cruz'
    ]
  },
  {
    region: 'Región del Maule',
    comunas: [
      'Talca',
      'Constitución',
      'Curepto',
      'Empedrado',
      'Maule',
      'Pelarco',
      'Pencahue',
      'Río Claro',
      'San Clemente',
      'San Rafael',
      'Cauquenes',
      'Chanco',
      'Pelluhue',
      'Curicó',
      'Hualañé',
      'Licantén',
      'Molina',
      'Rauco',
      'Romeral',
      'Sagrada Familia',
      'Teno',
      'Vichuquén',
      'Linares',
      'Colbún',
      'Longaví',
      'Parral',
      'Retiro',
      'San Javier de Loncomilla',
      'Villa Alegre',
      'Yerbas Buenas'
    ]
  },
  {
    region: 'Región del Biobío',
    comunas: [
      'Concepción',
      'Coronel',
      'Chiguayante',
      'Florida',
      'Hualqui',
      'Lota',
      'Penco',
      'San Pedro de la Paz',
      'Santa Juana',
      'Talcahuano',
      'Tomé',
      'Hualpén',
      'Lebu',
      'Arauco',
      'Cañete',
      'Contulmo',
      'Curanilahue',
      'Los Álamos',
      'Tirúa',
      'Los Ángeles',
      'Antuco',
      'Cabrero',
      'Laja',
      'Mulchén',
      'Nacimiento',
      'Negrete',
      'Quilaco',
      'Quilleco',
      'San Rosendo',
      'Santa Bárbara',
      'Tucapel',
      'Yumbel',
      'Alto Biobío'
    ]
  },
  {
    region: 'Región de la Araucanía',
    comunas: [
      'Temuco',
      'Carahue',
      'Cunco',
      'Curarrehue',
      'Freire',
      'Galvarino',
      'Gorbea',
      'Lautaro',
      'Loncoche',
      'Melipeuco',
      'Nueva Imperial',
      'Padre las Casas',
      'Perquenco',
      'Pitrufquén',
      'Pucón',
      'Saavedra',
      'Teodoro Schmidt',
      'Toltén',
      'Vilcún',
      'Villarrica',
      'Cholchol',
      'Angol',
      'Collipulli',
      'Curacautín',
      'Ercilla',
      'Lonquimay',
      'Los Sauces',
      'Lumaco',
      'Purén',
      'Renaico',
      'Traiguén',
      'Victoria'
    ]
  },
  {
    region: 'Región de Los Ríos',
    comunas: [
      'Valdivia',
      'Corral',
      'Lanco',
      'Los Lagos',
      'Máfil',
      'Mariquina',
      'Paillaco',
      'Panguipulli',
      'La Unión',
      'Futrono',
      'Lago Ranco',
      'Río Bueno'
    ]
  },
  {
    region: 'Región de Los Lagos',
    comunas: [
      'Puerto Montt',
      'Calbuco',
      'Cochamó',
      'Fresia',
      'Frutillar',
      'Los Muermos',
      'Llanquihue',
      'Maullín',
      'Puerto Varas',
      'Castro',
      'Ancud',
      'Chonchi',
      'Curaco de Vélez',
      'Dalcahue',
      'Puqueldón',
      'Queilén',
      'Quellón',
      'Quemchi',
      'Quinchao',
      'Osorno',
      'Puerto Octay',
      'Purranque',
      'Puyehue',
      'Río Negro',
      'San Juan de la Costa',
      'San Pablo',
      'Chaitén',
      'Futaleufú',
      'Hualaihué',
      'Palena'
    ]
  },
  {
    region: 'Región Aisén del Gral. Carlos Ibáñez del Campo',
    comunas: [
      'Coyhaique',
      'Lago Verde',
      'Aisén',
      'Cisnes',
      'Guaitecas',
      'Cochrane',
      'O’Higgins',
      'Tortel',
      'Chile Chico',
      'Río Ibáñez'
    ]
  },
  {
    region: 'Región de Magallanes y de la Antártica Chilena',
    comunas: [
      'Punta Arenas',
      'Laguna Blanca',
      'Río Verde',
      'San Gregorio',
      'Cabo de Hornos (Ex Navarino)',
      'Antártica',
      'Porvenir',
      'Primavera',
      'Timaukel',
      'Natales',
      'Torres del Paine',
      'Puerto Natales'
    ]
  },
  {
    region: 'Arica y Parinacota',
    comunas: ['Arica', 'Camarones', 'Putre', 'General Lagos']
  },
  {
    region: 'Región de Ñuble',
    comunas: [
      'Cobquecura',
      'Coelemu',
      'Ninhue',
      'Portezuelo',
      'Quirihue',
      'Ránquil',
      'Treguaco',
      'Bulnes',
      'Chillán Viejo',
      'Chillán',
      'El Carmen',
      'Pemuco',
      'Pinto',
      'Quillón',
      'San Ignacio',
      'Yungay',
      'Coihueco',
      'Ñiquén',
      'San Carlos',
      'San Fabián',
      'San Nicolás'
    ]
  },
  {
    region: 'Región de Aysén',
    comunas: [
      'Aysén',
      'Cisnes',
      'Guaitecas'
    ]
  },
];

export const NATIONALITY = ['CHILENA', 'AFGANA', 'ALBANESA', 'ALEMANA', 'ANDORRANA', 'ANGOLEÑA', 'ANTIGUANA', 'SAUDÍ', 'ARGELINA', 'ARGENTINA', 'ARMENIA', 'ARUBEÑA', 'AUSTRALIANA', 'AUSTRIACA', 'AZERBAIYANA', 'BAHAMEÑA', 'BANGLADESÍ', 'BARBADENSE', 'BAREINÍ', 'BELGA', 'BELICEÑA', 'BENINÉSA', 'BIELORRUSA', 'BIRMANA', 'BOLIVIANA', 'BOSNIA', 'BOTSUANA', 'BRASILEÑA', 'BRUNEANA', 'BÚLGARA', 'BURKINÉS', 'BURUNDÉSA', 'BUTANÉSA', 'CABOVERDIANA', 'CAMBOYANA', 'CAMERUNESA', 'CANADIENSE', 'CATARÍ', 'CHADIANA', 'CHINA', 'CHIPRIOTA', 'VATICANA', 'COLOMBIANA', 'COMORENSE', 'NORCOREANA', 'SURCOREANA', 'MARFILEÑA', 'COSTARRICENSE', 'CROATA', 'CUBANA', 'DANÉSA', 'DOMINIQUÉS', 'ECUATORIANA', 'EGIPCIA', 'SALVADOREÑA', 'EMIRATÍ', 'ERITREA', 'ESLOVACA', 'ESLOVENA', 'ESPAÑOLA', 'ESTADOUNIDENSE', 'ESTONIA', 'ETÍOPE', 'FILIPINA', 'FINLANDÉSA', 'FIYIANA', 'FRANCÉSA', 'GABONÉSA', 'GAMBIANA', 'GEORGIANA', 'GIBRALTAREÑA', 'GHANÉSA', 'GRANADINA', 'GRIEGA', 'GROENLANDÉSA', 'GUATEMALTECA', 'ECUATOGUINEANA', 'GUINEANA', 'GUINEANA', 'GUYANESA', 'HAITIANA', 'HONDUREÑA', 'HÚNGARA', 'HINDÚ', 'INDONESIA', 'IRAQUÍ', 'IRANÍ', 'IRLANDÉSA', 'ISLANDÉSA', 'COOKIANA', 'MARSHALÉSA', 'SALOMONENSE', 'ISRAELÍ', 'ITALIANA', 'JAMAIQUINA', 'JAPONÉSA', 'JORDANA', 'KAZAJA', 'KENIATA', 'KIRGUISA', 'KIRIBATIANA', 'KUWAITÍ', 'LAOSIANA', 'LESOTENSE', 'LETÓNA', 'LIBANÉSA', 'LIBERIANA', 'LIBIA', 'LIECHTENSTEINIANA', 'LITUANA', 'LUXEMBURGUÉSA', 'MALGACHE', 'MALASIA', 'MALAUÍ', 'MALDIVA', 'MALIENSE', 'MALTÉSA', 'MARROQUÍ', 'MARTINIQUÉS', 'MAURICIANA', 'MAURITANA', 'MEXICANA', 'MICRONESIA', 'MOLDAVA', 'MONEGASCA', 'MONGOLA', 'MONTENEGRINA', 'MOZAMBIQUEÑA', 'NAMIBIA', 'NAURUANA', 'NEPALÍ', 'NICARAGÜENSE', 'NIGERINA', 'NIGERIANA', 'NORUEGA', 'NEOZELANDÉSA', 'OMANÍ', 'NEERLANDÉSA', 'PAKISTANÍ', 'PALAUANA', 'PALESTINA', 'PANAMEÑA', 'PAPÚ', 'PARAGUAYA', 'PERUANA', 'POLACA', 'PORTUGUÉSA', 'PUERTORRIQUEÑA', 'BRITÁNICA', 'CENTROAFRICANA', 'CHECA', 'MACEDONIA', 'CONGOLEÑA', 'CONGOLEÑA', 'DOMINICANA', 'SUDAFRICANA', 'RUANDÉSA', 'RUMANA', 'RUSA', 'SAMOANA', 'CRISTOBALEÑA', 'SANMARINENSE', 'SANVICENTINA', 'SANTALUCENSE', 'SANTOTOMENSE', 'SENEGALÉSA', 'SERBIA', 'SEYCHELLENSE', 'SIERRALEONÉSA', 'SINGAPURENSE', 'SIRIA', 'SOMALÍ', 'CEILANÉSA', 'SUAZI', 'SURSUDANÉSA', 'SUDANÉSA', 'SUECA', 'SUIZA', 'SURINAMESA', 'TAILANDÉSA', 'TANZANA', 'TAYIKA', 'TIMORENSE', 'TOGOLÉSA', 'TONGANA', 'TRINITENSE', 'TUNECINA', 'TURCOMANA', 'TURCA', 'TUVALUANA', 'UCRANIANA', 'UGANDÉSA', 'URUGUAYA', 'UZBEKA', 'VANUATUENSE', 'VENEZOLANA', 'VIETNAMITA', 'YEMENÍ', 'YIBUTIANA', 'ZAMBIANA', 'ZIMBABUENSE'];

export const COMMERCIAL_BUSINESS = [{
  nombre: 'CULTIVO DE PLANTAS NO PERENNES',
  giros: [
    '11101, CULTIVO DE TRIGO', '11102, CULTIVO DE MAÍZ', '11103, CULTIVO DE AVENA', '11104, CULTIVO DE CEBADA', '11105, CULTIVO DE OTROS CEREALES (EXCEPTO TRIGO, MAÍZ, AVENA Y CEBADA)', '11106, CULTIVO DE POROTOS', '11107, CULTIVO DE LUPINO', '11108, CULTIVO DE OTRAS LEGUMBRES (EXCEPTO POROTOS Y LUPINO)', '11109, CULTIVO DE SEMILLAS DE RAPS', '11110, CULTIVO DE SEMILLAS DE MARAVILLA (GIRASOL)', '11111, CULTIVO DE SEMILLAS DE CEREALES, LEGUMBRES Y OLEAGINOSAS (EXCEPTO SEMILLAS DE RAPS Y MARAVILLA)', '11200, CULTIVO DE ARROZ', '11301, CULTIVO DE PAPAS', '11302, CULTIVO DE CAMOTES', '11303, CULTIVO DE OTROS TUBÉRCULOS (EXCEPTO PAPAS Y CAMOTES)', '11304, CULTIVO DE REMOLACHA AZUCARERA', '11305, CULTIVO DE SEMILLAS DE HORTALIZAS', '11306, CULTIVO DE HORTALIZAS Y MELONES', '11400, CULTIVO DE CAÑA DE AZÚCAR', '11500, CULTIVO DE TABACO', '11600, CULTIVO DE PLANTAS DE FIBRA', '11901, CULTIVO DE FLORES', '11902, CULTIVOS FORRAJEROS EN PRADERAS MEJORADAS O SEMBRADAS; CULTIVOS SUPLEMENTARIOS FORRAJEROS', '11903, CULTIVOS DE SEMILLAS DE FLORES; CULTIVO DE SEMILLAS DE PLANTAS FORRAJERAS']
}, {
  nombre: 'CULTIVO DE PLANTAS PERENNES',
  giros: ['12111, CULTIVO DE UVA DESTINADA A LA PRODUCCIÓN DE PISCO Y AGUARDIENTE', '12112, CULTIVO DE UVA DESTINADA A LA PRODUCCIÓN DE VINO', '12120, CULTIVO DE UVA PARA MESA', '12200, CULTIVO DE FRUTAS TROPICALES Y SUBTROPICALES (INCLUYE EL CULTIVO DE PALTAS)', '12300, CULTIVO DE CÍTRICOS', '12400, CULTIVO DE FRUTAS DE PEPITA Y DE HUESO', '12501, CULTIVO DE SEMILLAS DE FRUTAS', '12502, CULTIVO DE OTROS FRUTOS Y NUECES DE ÁRBOLES Y ARBUSTOS', '12600, CULTIVO DE FRUTOS OLEAGINOSOS (INCLUYE EL CULTIVO DE ACEITUNAS)', '12700, CULTIVO DE PLANTAS CON LAS QUE SE PREPARAN BEBIDAS (INCLUYE EL CULTIVO DE CAFÉ, TÉ Y MATE)', '12801, CULTIVO DE ESPECIAS', '12802, CULTIVO DE PLANTAS AROMÁTICAS, MEDICINALES Y FARMACÉUTICAS', '12900, CULTIVO DE OTRAS PLANTAS PERENNES']
}, {
  nombre: 'PROPAGACIÓN DE PLANTAS',
  giros: ['13000, CULTIVO DE PLANTAS VIVAS INCLUIDA LA PRODUCCIÓN EN VIVEROS (EXCEPTO VIVEROS FORESTALES)']
}, {
  nombre: 'GANADERÍA',
  giros: ['14101, CRÍA DE GANADO BOVINO PARA LA PRODUCCIÓN LECHERA', '14102, CRÍA DE GANADO BOVINO PARA LA PRODUCCIÓN DE CARNE O COMO GANADO REPRODUCTOR', '14200, CRÍA DE CABALLOS Y OTROS EQUINOS', '14300, CRÍA DE LLAMAS, ALPACAS, VICUÑAS, GUANACOS Y OTROS CAMÉLIDOS', '14410, CRÍA DE OVEJAS (OVINOS)', '14420, CRÍA DE CABRAS (CAPRINOS)', '14500, CRÍA DE CERDOS', '14601, CRÍA DE AVES DE CORRAL PARA LA PRODUCCIÓN DE CARNE', '14602, CRÍA DE AVES DE CORRAL PARA LA PRODUCCIÓN DE HUEVOS', '14901, APICULTURA', '14909, CRÍA DE OTROS ANIMALES N.C.P.']
}, {
  nombre: 'CULTIVO DE PRODUCTOS AGRÍCOLAS EN COMBINACIÓN CON LA CRÍA DE ANIMALES',
  giros: ['15000, CULTIVO DE PRODUCTOS AGRÍCOLAS EN COMBINACIÓN CON LA CRÍA DE ANIMALES (EXPLOTACIÓN MIXTA)']
}, {
  nombre: 'ACTIVIDADES DE APOYO A LA AGRICULTURA Y LA GANADERÍA Y ACTIVIDADES POSCOSECHA',
  giros: ['16100, ACTIVIDADES DE APOYO A LA AGRICULTURA', '16200, ACTIVIDADES DE APOYO A LA GANADERÍA', '16300, ACTIVIDADES POSCOSECHA', '16400, TRATAMIENTO DE SEMILLAS PARA PROPAGACIÓN']
}, {
  nombre: 'CAZA ORDINARIA Y MEDIANTE TRAMPAS Y ACTIVIDADES DE SERVICIOS CONEXAS',
  giros: ['17000, CAZA ORDINARIA Y MEDIANTE TRAMPAS Y ACTIVIDADES DE SERVICIOS CONEXAS']
}, {
  nombre: 'SILVICULTURA Y OTRAS ACTIVIDADES FORESTALES',
  giros: ['21001, EXPLOTACIÓN DE VIVEROS FORESTALES', '21002, SILVICULTURA Y OTRAS ACTIVIDADES FORESTALES (EXCEPTO EXPLOTACIÓN DE VIVEROS FORESTALES)']
}, {
  nombre: 'EXTRACCIÓN DE MADERA',
  giros: ['22000, EXTRACCIÓN DE MADERA']
}, {
  nombre: 'RECOLECCIÓN DE PRODUCTOS FORESTALES DISTINTOS DE LA MADERA',
  giros: ['23000, RECOLECCIÓN DE PRODUCTOS FORESTALES DISTINTOS DE LA MADERA']
}, {
  nombre: 'SERVICIOS DE APOYO A LA SILVICULTURA',
  giros: ['24001, SERVICIOS DE FORESTACIÓN A CAMBIO DE UNA RETRIBUCIÓN O POR CONTRATA', '24002, SERVICIOS DE CORTA DE MADERA A CAMBIO DE UNA RETRIBUCIÓN O POR CONTRATA', '24003, SERVICIOS DE EXTINCIÓN Y PREVENCIÓN DE INCENDIOS FORESTALES', '24009, OTROS SERVICIOS DE APOYO A LA SILVICULTURA N.C.P.']
}, {
  nombre: 'PESCA',
  giros: ['31110, PESCA MARÍTIMA INDUSTRIAL, EXCEPTO DE BARCOS FACTORÍA', '31120, PESCA MARÍTIMA ARTESANAL', '31130, RECOLECCIÓN Y EXTRACCIÓN DE PRODUCTOS MARINOS', '31140, SERVICIOS RELACIONADOS CON LA PESCA MARÍTIMA', '31200, PESCA DE AGUA DULCE']
}, {
  nombre: 'ACUICULTURA',
  giros: ['32110, CULTIVO Y CRIANZA DE PECES MARINOS', '32120, CULTIVO, REPRODUCCIÓN Y MANEJO DE ALGAS MARINAS', '32130, REPRODUCCIÓN Y CRÍA DE MOLUSCOS, CRUSTÁCEOS Y GUSANOS MARINOS', '32140, SERVICIOS RELACIONADOS CON LA ACUICULTURA MARINA', '32200, ACUICULTURA DE AGUA DULCE']
}, {
  nombre: 'EXTRACCIÓN Y PROCESAMIENTO DE COBRE',
  giros: ['40000, EXTRACCIÓN Y PROCESAMIENTO DE COBRE']
}, {
  nombre: 'EXTRACCIÓN DE CARBÓN DE PIEDRA',
  giros: ['51000, EXTRACCIÓN DE CARBÓN DE PIEDRA']
}, {
  nombre: 'EXTRACCIÓN DE LIGNITO',
  giros: ['52000, EXTRACCIÓN DE LIGNITO']
}, {
  nombre: 'EXTRACCIÓN DE PETRÓLEO CRUDO',
  giros: ['61000, EXTRACCIÓN DE PETRÓLEO CRUDO']
}, {
  nombre: 'EXTRACCIÓN DE GAS NATURAL',
  giros: ['62000, EXTRACCIÓN DE GAS NATURAL']
}, {
  nombre: 'EXTRACCIÓN DE MINERALES DE HIERRO',
  giros: ['71000, EXTRACCIÓN DE MINERALES DE HIERRO', '72100, EXTRACCIÓN DE MINERALES DE URANIO Y TORIO', '72910, EXTRACCIÓN DE ORO Y PLATA', '72991, EXTRACCIÓN DE ZINC Y PLOMO', '72992, EXTRACCIÓN DE MANGANESO', '72999, EXTRACCIÓN DE OTROS MINERALES METALÍFEROS NO FERROSOS N.C.P. (EXCEPTO ZINC, PLOMO Y MANGANESO)']
}, {
  nombre: 'EXTRACCIÓN DE PIEDRA',
  giros: ['81000, EXTRACCIÓN DE PIEDRA, ARENA Y ARCILLA']
}, {
  nombre: 'EXPLOTACIÓN DE MINAS Y CANTERAS N.C.P.',
  giros: ['89110, EXTRACCIÓN Y PROCESAMIENTO DE LITIO', '89190, EXTRACCIÓN DE MINERALES PARA LA FABRICACIÓN DE ABONOS Y PRODUCTOS QUÍMICOS N.C.P.', '89200, EXTRACCIÓN DE TURBA', '89300, EXTRACCIÓN DE SAL', '89900, EXPLOTACIÓN DE OTRAS MINAS Y CANTERAS N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE APOYO PARA LA EXTRACCIÓN DE PETRÓLEO Y GAS NATURAL',
  giros: ['91001, ACTIVIDADES DE APOYO PARA LA EXTRACCIÓN DE PETRÓLEO Y GAS NATURAL PRESTADOS POR EMPRESAS', '91002, ACTIVIDADES DE APOYO PARA LA EXTRACCIÓN DE PETRÓLEO Y GAS NATURAL PRESTADOS POR PROFESIONALES']
}, {
  nombre: 'ACTIVIDADES DE APOYO PARA LA EXPLOTACIÓN DE OTRAS MINAS Y CANTERAS',
  giros: ['99001, ACTIVIDADES DE APOYO PARA LA EXPLOTACIÓN DE OTRAS MINAS Y CANTERAS PRESTADOS POR EMPRESAS', '99002, ACTIVIDADES DE APOYO PARA LA EXPLOTACIÓN DE OTRAS MINAS Y CANTERAS PRESTADOS POR PROFESIONALES']
}, {
  nombre: 'ELABORACIÓN Y CONSERVACIÓN DE CARNE',
  giros: ['101011, EXPLOTACIÓN DE MATADEROS DE BOVINOS, OVINOS, EQUINOS, CAPRINOS, PORCINOS Y CAMÉLIDOS', '101019, EXPLOTACIÓN DE MATADEROS DE AVES Y DE OTROS TIPOS DE ANIMALES N.C.P.', '101020, ELABORACIÓN Y CONSERVACIÓN DE CARNE Y PRODUCTOS CÁRNICOS']
}, {
  nombre: 'ELABORACIÓN Y CONSERVACIÓN DE PESCADO',
  giros: ['102010, PRODUCCIÓN DE HARINA DE PESCADO', '102020, ELABORACIÓN Y CONSERVACIÓN DE SALMÓNIDOS', '102030, ELABORACIÓN Y CONSERVACIÓN DE OTROS PESCADOS, EN PLANTAS EN TIERRA (EXCEPTO BARCOS FACTORÍA)', '102040, ELABORACIÓN Y CONSERVACIÓN DE CRUSTÁCEOS, MOLUSCOS Y OTROS PRODUCTOS ACUÁTICOS, EN PLANTAS EN TIERRA', '102050, ACTIVIDADES DE ELABORACIÓN Y CONSERVACIÓN DE PESCADO, REALIZADAS EN BARCOS FACTORÍA', '102060, ELABORACIÓN Y PROCESAMIENTO DE ALGAS']
}, {
  nombre: 'ELABORACIÓN Y CONSERVACIÓN DE FRUTAS',
  giros: ['103000, ELABORACIÓN Y CONSERVACIÓN DE FRUTAS, LEGUMBRES Y HORTALIZAS']
}, {
  nombre: 'ELABORACIÓN DE ACEITES Y GRASAS DE ORIGEN VEGETAL Y ANIMAL',
  giros: ['104000, ELABORACIÓN DE ACEITES Y GRASAS DE ORIGEN VEGETAL Y ANIMAL (EXCEPTO ELABORACIÓN DE MANTEQUILLA)']
}, {
  nombre: 'ELABORACIÓN DE PRODUCTOS LÁCTEOS',
  giros: ['105000, ELABORACIÓN DE PRODUCTOS LÁCTEOS']
}, {
  nombre: 'ELABORACIÓN DE PRODUCTOS DE MOLINERÍA',
  giros: ['106101, MOLIENDA DE TRIGO: PRODUCCIÓN DE HARINA, SÉMOLA Y GRÁNULOS', '106102, MOLIENDA DE ARROZ; PRODUCCIÓN DE HARINA DE ARROZ', '106109, ELABORACIÓN DE OTROS PRODUCTOS DE MOLINERÍA N.C.P.', '106200, ELABORACIÓN DE ALMIDONES Y PRODUCTOS DERIVADOS DEL ALMIDÓN']
}, {
  nombre: 'ELABORACIÓN DE OTROS PRODUCTOS ALIMENTICIOS',
  giros: ['107100, ELABORACIÓN DE PRODUCTOS DE PANADERÍA Y PASTELERÍA', '107200, ELABORACIÓN DE AZÚCAR', '107300, ELABORACIÓN DE CACAO, CHOCOLATE Y DE PRODUCTOS DE CONFITERÍA', '107400, ELABORACIÓN DE MACARRONES, FIDEOS, ALCUZCUZ Y PRODUCTOS FARINÁCEOS SIMILARES', '107500, ELABORACIÓN DE COMIDAS Y PLATOS PREPARADOS ENVASADOS, ROTULADOS Y CON INFORMACIÓN NUTRICIONAL', '107901, ELABORACIÓN DE TÉ, CAFÉ, MATE E INFUSIONES DE HIERBAS', '107902, ELABORACIÓN DE LEVADURAS NATURALES O ARTIFICIALES', '107903, ELABORACIÓN DE VINAGRES, MOSTAZAS, MAYONESAS Y CONDIMENTOS EN GENERAL', '107909, ELABORACIÓN DE OTROS PRODUCTOS ALIMENTICIOS N.C.P.']
}, {
  nombre: 'ELABORACIÓN DE PIENSOS PREPARADOS PARA ANIMALES',
  giros: ['108000, ELABORACIÓN DE PIENSOS PREPARADOS PARA ANIMALES']
}, {
  nombre: 'ELABORACIÓN DE BEBIDAS ALCOHÓLICAS Y NO ALCOHÓLICAS',
  giros: ['110110, ELABORACIÓN DE PISCO (INDUSTRIAS PISQUERAS)', '110120, DESTILACIÓN, RECTIFICACIÓN Y MEZCLAS DE BEBIDAS ALCOHÓLICAS; EXCEPTO PISCO', '110200, ELABORACIÓN DE VINOS', '110300, ELABORACIÓN DE BEBIDAS MALTEADAS Y DE MALTA', '110401, ELABORACIÓN DE BEBIDAS NO ALCOHÓLICAS', '110402, PRODUCCIÓN DE AGUAS MINERALES Y OTRAS AGUAS EMBOTELLADAS']
}, {
  nombre: 'ELABORACIÓN DE PRODUCTOS DE TABACO',
  giros: ['120001, ELABORACIÓN DE CIGARROS Y CIGARRILLOS', '120009, ELABORACIÓN DE OTROS PRODUCTOS DE TABACO N.C.P.']
}, {
  nombre: 'HILATURA',
  giros: ['131100, PREPARACIÓN E HILATURA DE FIBRAS TEXTILES', '131200, TEJEDURA DE PRODUCTOS TEXTILES', '131300, ACABADO DE PRODUCTOS TEXTILES']
}, {
  nombre: 'FABRICACIÓN DE OTROS PRODUCTOS TEXTILES',
  giros: ['139100, FABRICACIÓN DE TEJIDOS DE PUNTO Y GANCHILLO', '139200, FABRICACIÓN DE ARTÍCULOS CONFECCIONADOS DE MATERIALES TEXTILES, EXCEPTO PRENDAS DE VESTIR', '139300, FABRICACIÓN DE TAPICES Y ALFOMBRAS', '139400, FABRICACIÓN DE CUERDAS, CORDELES, BRAMANTES Y REDES', '139900, FABRICACIÓN DE OTROS PRODUCTOS TEXTILES N.C.P.']
}, {
  nombre: 'FABRICACIÓN DE PRENDAS DE VESTIR',
  giros: ['141001, FABRICACIÓN DE PRENDAS DE VESTIR DE MATERIALES TEXTILES Y SIMILARES', '141002, FABRICACIÓN DE PRENDAS DE VESTIR DE CUERO NATURAL O ARTIFICIAL', '141003, FABRICACIÓN DE ACCESORIOS DE VESTIR', '141004, FABRICACIÓN DE ROPA DE TRABAJO']
}, {
  nombre: 'FABRICACIÓN DE ARTÍCULOS DE PIEL',
  giros: ['142000, FABRICACIÓN DE ARTÍCULOS DE PIEL']
}, {
  nombre: 'FABRICACIÓN DE ARTÍCULOS DE PUNTO Y GANCHILLO',
  giros: ['143000, FABRICACIÓN DE ARTÍCULOS DE PUNTO Y GANCHILLO']
}, {
  nombre: 'CURTIDO Y ADOBO DE CUEROS; FABRICACIÓN PRODUCTOS DE CUERO; ADOBO Y TEÑIDO DE PIELES',
  giros: ['151100, CURTIDO Y ADOBO DE CUEROS; ADOBO Y TEÑIDO DE PIELES', '151200, FABRICACIÓN DE MALETAS, BOLSOS Y ARTÍCULOS SIMILARES, ARTÍCULOS DE TALABARTERÍA Y GUARNICIONERÍA']
}, {
  nombre: 'FABRICACIÓN DE CALZADO',
  giros: ['152000, FABRICACIÓN DE CALZADO']
}, {
  nombre: 'ASERRADO Y ACEPILLADURA DE MADERA',
  giros: ['161000, ASERRADO Y ACEPILLADURA DE MADERA']
}, {
  nombre: 'FABRICACIÓN DE PRODUCTOS DE MADERA',
  giros: ['162100, FABRICACIÓN DE HOJAS DE MADERA PARA ENCHAPADO Y TABLEROS A BASE DE MADERA', '162200, FABRICACIÓN DE PARTES Y PIEZAS DE CARPINTERÍA PARA EDIFICIOS Y CONSTRUCCIONES', '162300, FABRICACIÓN DE RECIPIENTES DE MADERA', '162900, FABRICACIÓN DE OTROS PRODUCTOS DE MADERA, DE ARTÍCULOS DE CORCHO, PAJA Y MATERIALES TRENZABLES']
}, {
  nombre: 'FABRICACIÓN DE PAPEL Y DE PRODUCTOS DE PAPEL',
  giros: ['170110, FABRICACIÓN DE CELULOSA Y OTRAS PASTAS DE MADERA', '170190, FABRICACIÓN DE PAPEL Y CARTÓN PARA SU POSTERIOR USO INDUSTRIAL N.C.P.', '170200, FABRICACIÓN DE PAPEL Y CARTÓN ONDULADO Y DE ENVASES DE PAPEL Y CARTÓN', '170900, FABRICACIÓN DE OTROS ARTÍCULOS DE PAPEL Y CARTÓN']
}, {
  nombre: 'IMPRESIÓN Y ACTIVIDADES DE SERVICIOS RELACIONADAS CON LA IMPRESIÓN',
  giros: ['181101, IMPRESIÓN DE LIBROS', '181109, OTRAS ACTIVIDADES DE IMPRESIÓN N.C.P.', '181200, ACTIVIDADES DE SERVICIOS RELACIONADAS CON LA IMPRESIÓN']
}, {
  nombre: 'REPRODUCCIÓN DE GRABACIONES',
  giros: ['182000, REPRODUCCIÓN DE GRABACIONES']
}, {
  nombre: 'FABRICACIÓN DE PRODUCTOS DE HORNOS DE COQUE',
  giros: ['191000, FABRICACIÓN DE PRODUCTOS DE HORNOS DE COQUE']
}, {
  nombre: 'FABRICACIÓN DE PRODUCTOS DE LA REFINACIÓN DEL PETRÓLEO',
  giros: ['192000, FABRICACIÓN DE PRODUCTOS DE LA REFINACIÓN DEL PETRÓLEO']
}, {
  nombre: 'FABRICACIÓN SUSTANCIAS QUÍMICAS BÁSICAS',
  giros: ['201101, FABRICACIÓN DE CARBÓN VEGETAL (EXCEPTO ACTIVADO); FABRICACIÓN DE BRIQUETAS DE CARBÓN VEGETAL', '201109, FABRICACIÓN DE OTRAS SUSTANCIAS QUÍMICAS BÁSICAS N.C.P.', '201200, FABRICACIÓN DE ABONOS Y COMPUESTOS DE NITRÓGENO', '201300, FABRICACIÓN DE PLÁSTICOS Y CAUCHO SINTÉTICO EN FORMAS PRIMARIAS']
}, {
  nombre: 'FABRICACIÓN DE OTROS PRODUCTOS QUÍMICOS',
  giros: ['202100, FABRICACIÓN DE PLAGUICIDAS Y OTROS PRODUCTOS QUÍMICOS DE USO AGROPECUARIO', '202200, FABRICACIÓN DE PINTURAS, BARNICES Y PRODUCTOS DE REVESTIMIENTO, TINTAS DE IMPRENTA Y MASILLAS', '202300, FABRICACIÓN DE JABONES Y DETERGENTES, PREPARADOS PARA LIMPIAR, PERFUMES Y PREPARADOS DE TOCADOR', '202901, FABRICACIÓN DE EXPLOSIVOS Y PRODUCTOS PIROTÉCNICOS', '202909, FABRICACIÓN DE OTROS PRODUCTOS QUÍMICOS N.C.P.']
}, {
  nombre: 'FABRICACIÓN DE FIBRAS ARTIFICIALES',
  giros: ['203000, FABRICACIÓN DE FIBRAS ARTIFICIALES']
}, {
  nombre: 'FABRICACIÓN DE PRODUCTOS FARMACÉUTICOS',
  giros: ['210000, FABRICACIÓN DE PRODUCTOS FARMACÉUTICOS, SUSTANCIAS QUÍMICAS MEDICINALES Y PRODUCTOS BOTÁNICOS']
}, {
  nombre: 'FABRICACIÓN DE PRODUCTOS DE CAUCHO',
  giros: ['221100, FABRICACIÓN DE CUBIERTAS Y CÁMARAS DE CAUCHO; RECAUCHUTADO Y RENOVACIÓN DE CUBIERTAS DE CAUCHO', '221900, FABRICACIÓN DE OTROS PRODUCTOS DE CAUCHO']
}, {
  nombre: 'FABRICACIÓN DE PRODUCTOS DE PLÁSTICO',
  giros: ['222000, FABRICACIÓN DE PRODUCTOS DE PLÁSTICO']
}, {
  nombre: 'FABRICACIÓN DE VIDRIO Y PRODUCTOS DE VIDRIO',
  giros: ['231001, FABRICACIÓN DE VIDRIO PLANO', '231002, FABRICACIÓN DE VIDRIO HUECO', '231003, FABRICACIÓN DE FIBRAS DE VIDRIO', '231009, FABRICACIÓN DE PRODUCTOS DE VIDRIO N.C.P.']
}, {
  nombre: 'FABRICACIÓN DE PRODUCTOS MINERALES NO METÁLICOS N.C.P.',
  giros: ['239100, FABRICACIÓN DE PRODUCTOS REFRACTARIOS', '239200, FABRICACIÓN DE MATERIALES DE CONSTRUCCIÓN DE ARCILLA', '239300, FABRICACIÓN DE OTROS PRODUCTOS DE PORCELANA Y DE CERÁMICA', '239400, FABRICACIÓN DE CEMENTO, CAL Y YESO', '239500, FABRICACIÓN DE ARTÍCULOS DE HORMIGÓN, CEMENTO Y YESO', '239600, CORTE, TALLA Y ACABADO DE LA PIEDRA', '239900, FABRICACIÓN DE OTROS PRODUCTOS MINERALES NO METÁLICOS N.C.P.']
}, {
  nombre: 'INDUSTRIAS BÁSICAS DE HIERRO Y ACERO',
  giros: ['241000, INDUSTRIAS BÁSICAS DE HIERRO Y ACERO']
}, {
  nombre: 'FABRICACIÓN DE PRODUCTOS PRIMARIOS DE METALES PRECIOSOS Y OTROS METALES NO FERROSOS',
  giros: ['242001, FABRICACIÓN DE PRODUCTOS PRIMARIOS DE COBRE', '242002, FABRICACIÓN DE PRODUCTOS PRIMARIOS DE ALUMINIO', '242009, FABRICACIÓN DE PRODUCTOS PRIMARIOS DE METALES PRECIOSOS Y DE OTROS METALES NO FERROSOS N.C.P.']
}, {
  nombre: 'FUNDICIÓN DE METALES',
  giros: ['243100, FUNDICIÓN DE HIERRO Y ACERO', '243200, FUNDICIÓN DE METALES NO FERROSOS']
}, {
  nombre: 'FABRICACIÓN DE PRODUCTOS METÁLICOS PARA USO ESTRUCTURAL',
  giros: ['251100, FABRICACIÓN DE PRODUCTOS METÁLICOS PARA USO ESTRUCTURAL', '251201, FABRICACIÓN DE RECIPIENTES DE METAL PARA GASES COMPRIMIDOS O LICUADOS', '251209, FABRICACIÓN DE TANQUES, DEPÓSITOS Y RECIPIENTES DE METAL N.C.P.', '251300, FABRICACIÓN DE GENERADORES DE VAPOR, EXCEPTO CALDERAS DE AGUA CALIENTE PARA CALEFACCIÓN CENTRAL']
}, {
  nombre: 'FABRICACIÓN DE ARMAS Y MUNICIONES',
  giros: ['252000, FABRICACIÓN DE ARMAS Y MUNICIONES']
}, {
  nombre: 'FABRICACIÓN DE OTROS PRODUCTOS ELABORADOS DE METAL; ACTIVIDADES DE SERVICIOS DE TRABAJO DE METALES',
  giros: ['259100, FORJA, PRENSADO, ESTAMPADO Y LAMINADO DE METALES; PULVIMETALURGIA', '259200, TRATAMIENTO Y REVESTIMIENTO DE METALES; MAQUINADO', '259300, FABRICACIÓN DE ARTÍCULOS DE CUCHILLERÍA, HERRAMIENTAS DE MANO Y ARTÍCULOS DE FERRETERÍA', '259900, FABRICACIÓN DE OTROS PRODUCTOS ELABORADOS DE METAL N.C.P.']
}, {
  nombre: 'FABRICACIÓN DE COMPONENTES Y TABLEROS ELECTRÓNICOS',
  giros: ['261000, FABRICACIÓN DE COMPONENTES Y TABLEROS ELECTRÓNICOS']
}, {
  nombre: 'FABRICACIÓN DE COMPUTADORES Y EQUIPO PERIFÉRICO',
  giros: ['262000, FABRICACIÓN DE COMPUTADORES Y EQUIPO PERIFÉRICO']
}, {
  nombre: 'FABRICACIÓN DE EQUIPO DE COMUNICACIONES',
  giros: ['263000, FABRICACIÓN DE EQUIPO DE COMUNICACIONES']
}, {
  nombre: 'FABRICACIÓN DE APARATOS ELECTRÓNICOS DE CONSUMO',
  giros: ['264000, FABRICACIÓN DE APARATOS ELECTRÓNICOS DE CONSUMO']
}, {
  nombre: 'FABRICACIÓN DE EQUIPO DE MEDICIÓN',
  giros: ['265100, FABRICACIÓN DE EQUIPO DE MEDICIÓN, PRUEBA, NAVEGACIÓN Y CONTROL', '265200, FABRICACIÓN DE RELOJES']
}, {
  nombre: 'FABRICACIÓN DE EQUIPO DE IRRADIACIÓN Y EQUIPO ELECTRÓNICO DE USO MÉDICO Y TERAPÉUTICO',
  giros: ['266000, FABRICACIÓN DE EQUIPO DE IRRADIACIÓN Y EQUIPO ELECTRÓNICO DE USO MÉDICO Y TERAPÉUTICO']
}, {
  nombre: 'FABRICACIÓN DE INSTRUMENTOS ÓPTICOS Y EQUIPO FOTOGRÁFICO',
  giros: ['267000, FABRICACIÓN DE INSTRUMENTOS ÓPTICOS Y EQUIPO FOTOGRÁFICO']
}, {
  nombre: 'FABRICACIÓN DE SOPORTES MAGNÉTICOS Y ÓPTICOS',
  giros: ['268000, FABRICACIÓN DE SOPORTES MAGNÉTICOS Y ÓPTICOS']
}, {
  nombre: 'FABRICACIÓN DE MOTORES',
  giros: ['271000, FABRICACIÓN DE MOTORES, GENERADORES Y TRANSFORMADORES ELÉCTRICOS, APARATOS DE DISTRIBUCIÓN Y CONTROL']
}, {
  nombre: 'FABRICACIÓN DE PILAS',
  giros: ['272000, FABRICACIÓN DE PILAS, BATERÍAS Y ACUMULADORES']
}, {
  nombre: 'FABRICACIÓN DE CABLES Y DISPOSITIVOS DE CABLEADO',
  giros: ['273100, FABRICACIÓN DE CABLES DE FIBRA ÓPTICA', '273200, FABRICACIÓN DE OTROS HILOS Y CABLES ELÉCTRICOS', '273300, FABRICACIÓN DE DISPOSITIVOS DE CABLEADO']
}, {
  nombre: 'FABRICACIÓN DE EQUIPO ELÉCTRICO DE ILUMINACIÓN',
  giros: ['274000, FABRICACIÓN DE EQUIPO ELÉCTRICO DE ILUMINACIÓN']
}, {
  nombre: 'FABRICACIÓN DE APARATOS DE USO DOMÉSTICO',
  giros: ['275000, FABRICACIÓN DE APARATOS DE USO DOMÉSTICO']
}, {
  nombre: 'FABRICACIÓN DE OTROS TIPOS DE EQUIPO ELÉCTRICO',
  giros: ['279000, FABRICACIÓN DE OTROS TIPOS DE EQUIPO ELÉCTRICO']
}, {
  nombre: 'FABRICACIÓN DE MAQUINARIA DE USO GENERAL',
  giros: ['281100, FABRICACIÓN DE MOTORES Y TURBINAS, EXCEPTO PARA AERONAVES, VEHÍCULOS AUTOMOTORES Y MOTOCICLETAS', '281200, FABRICACIÓN DE EQUIPO DE PROPULSIÓN DE FLUIDOS', '281300, FABRICACIÓN DE OTRAS BOMBAS, COMPRESORES, GRIFOS Y VÁLVULAS', '281400, FABRICACIÓN DE COJINETES, ENGRANAJES, TRENES DE ENGRANAJES Y PIEZAS DE TRANSMISIÓN', '281500, FABRICACIÓN DE HORNOS, CALDERAS Y QUEMADORES', '281600, FABRICACIÓN DE EQUIPO DE ELEVACIÓN Y MANIPULACIÓN', '281700, FABRICACIÓN DE MAQUINARIA Y EQUIPO DE OFICINA (EXCEPTO COMPUTADORES Y EQUIPO PERIFÉRICO)', '281800, FABRICACIÓN DE HERRAMIENTAS DE MANO MOTORIZADAS', '281900, FABRICACIÓN DE OTROS TIPOS DE MAQUINARIA DE USO GENERAL']
}, {
  nombre: 'FABRICACIÓN DE MAQUINARIA DE USO ESPECIAL',
  giros: ['282100, FABRICACIÓN DE MAQUINARIA AGROPECUARIA Y FORESTAL', '282200, FABRICACIÓN DE MAQUINARIA PARA LA CONFORMACIÓN DE METALES Y DE MÁQUINAS HERRAMIENTA', '282300, FABRICACIÓN DE MAQUINARIA METALÚRGICA', '282400, FABRICACIÓN DE MAQUINARIA PARA LA EXPLOTACIÓN DE MINAS Y CANTERAS Y PARA OBRAS DE CONSTRUCCIÓN', '282500, FABRICACIÓN DE MAQUINARIA PARA LA ELABORACIÓN DE ALIMENTOS, BEBIDAS Y TABACO', '282600, FABRICACIÓN DE MAQUINARIA PARA LA ELABORACIÓN DE PRODUCTOS TEXTILES, PRENDAS DE VESTIR Y CUEROS', '282900, FABRICACIÓN DE OTROS TIPOS DE MAQUINARIA DE USO ESPECIAL']
}, {
  nombre: 'FABRICACIÓN DE VEHÍCULOS AUTOMOTORES',
  giros: ['291000, FABRICACIÓN DE VEHÍCULOS AUTOMOTORES']
}, {
  nombre: 'FABRICACIÓN DE CARROCERÍAS PARA VEHÍCULOS AUTOMOTORES; FABRICACIÓN DE REMOLQUES Y SEMIRREMOLQUES',
  giros: ['292000, FABRICACIÓN DE CARROCERÍAS PARA VEHÍCULOS AUTOMOTORES; FABRICACIÓN DE REMOLQUES Y SEMIRREMOLQUES']
}, {
  nombre: 'FABRICACIÓN DE PARTES',
  giros: ['293000, FABRICACIÓN DE PARTES, PIEZAS Y ACCESORIOS PARA VEHÍCULOS AUTOMOTORES']
}, {
  nombre: 'CONSTRUCCIÓN DE BUQUES Y OTRAS EMBARCACIONES',
  giros: ['301100, CONSTRUCCIÓN DE BUQUES, EMBARCACIONES MENORES Y ESTRUCTURAS FLOTANTES', '301200, CONSTRUCCIÓN DE EMBARCACIONES DE RECREO Y DE DEPORTE']
}, {
  nombre: 'FABRICACIÓN DE LOCOMOTORAS Y MATERIAL RODANTE',
  giros: ['302000, FABRICACIÓN DE LOCOMOTORAS Y MATERIAL RODANTE']
}, {
  nombre: 'FABRICACIÓN DE AERONAVES',
  giros: ['303000, FABRICACIÓN DE AERONAVES, NAVES ESPACIALES Y MAQUINARIA CONEXA']
}, {
  nombre: 'FABRICACIÓN DE VEHÍCULOS MILITARES DE COMBATE',
  giros: ['304000, FABRICACIÓN DE VEHÍCULOS MILITARES DE COMBATE']
}, {
  nombre: 'FABRICACIÓN DE EQUIPO DE TRANSPORTE N.C.P.',
  giros: ['309100, FABRICACIÓN DE MOTOCICLETAS', '309200, FABRICACIÓN DE BICICLETAS Y DE SILLAS DE RUEDAS', '309900, FABRICACIÓN DE OTROS TIPOS DE EQUIPO DE TRANSPORTE N.C.P.']
}, {
  nombre: 'FABRICACIÓN DE MUEBLES',
  giros: ['310001, FABRICACIÓN DE MUEBLES PRINCIPALMENTE DE MADERA', '310009, FABRICACIÓN DE COLCHONES; FABRICACIÓN DE OTROS MUEBLES N.C.P.']
}, {
  nombre: 'FABRICACIÓN DE JOYAS',
  giros: ['321100, FABRICACIÓN DE JOYAS Y ARTÍCULOS CONEXOS', '321200, FABRICACIÓN DE BISUTERÍA Y ARTÍCULOS CONEXOS']
}, {
  nombre: 'FABRICACIÓN DE INSTRUMENTOS MUSICALES',
  giros: ['322000, FABRICACIÓN DE INSTRUMENTOS MUSICALES']
}, {
  nombre: 'FABRICACIÓN DE ARTÍCULOS DE DEPORTE',
  giros: ['323000, FABRICACIÓN DE ARTÍCULOS DE DEPORTE']
}, {
  nombre: 'FABRICACIÓN DE JUEGOS Y JUGUETES',
  giros: ['324000, FABRICACIÓN DE JUEGOS Y JUGUETES']
}, {
  nombre: 'FABRICACIÓN DE INSTRUMENTOS Y MATERIALES MÉDICOS Y ODONTOLÓGICOS',
  giros: ['325001, ACTIVIDADES DE LABORATORIOS DENTALES', '325009, FABRICACIÓN DE INSTRUMENTOS Y MATERIALES MÉDICOS, OFTALMOLÓGICOS Y ODONTOLÓGICOS N.C.P.']
}, {
  nombre: 'OTRAS INDUSTRIAS MANUFACTURERAS N.C.P.',
  giros: ['329000, OTRAS INDUSTRIAS MANUFACTURERAS N.C.P.']
}, {
  nombre: 'REPARACIÓN DE PRODUCTOS ELABORADOS DE METAL',
  giros: ['331100, REPARACIÓN DE PRODUCTOS ELABORADOS DE METAL', '331201, REPARACIÓN DE MAQUINARIA AGROPECUARIA Y FORESTAL', '331202, REPARACIÓN DE MAQUINARIA METALÚRGICA, PARA LA MINERÍA, EXTRACCIÓN DE PETRÓLEO Y PARA LA CONSTRUCCIÓN', '331203, REPARACIÓN DE MAQUINARIA PARA LA ELABORACIÓN DE ALIMENTOS, BEBIDAS Y TABACO', '331204, REPARACIÓN DE MAQUINARIA PARA PRODUCIR TEXTILES, PRENDAS DE VESTIR, ARTÍCULOS DE CUERO Y CALZADO', '331209, REPARACIÓN DE OTRO TIPO DE MAQUINARIA Y EQUIPOS INDUSTRIALES N.C.P.', '331301, REPARACIÓN DE EQUIPO DE MEDICIÓN, PRUEBA, NAVEGACIÓN Y CONTROL', '331309, REPARACIÓN DE OTROS EQUIPOS ELECTRÓNICOS Y ÓPTICOS N.C.P.', '331400, REPARACIÓN DE EQUIPO ELÉCTRICO (EXCEPTO REPARACIÓN DE EQUIPO Y ENSERES DOMÉSTICOS)', '331501, REPARACIÓN DE BUQUES, EMBARCACIONES MENORES Y ESTRUCTURAS FLOTANTES', '331502, REPARACIÓN DE AERONAVES Y NAVES ESPACIALES', '331509, REPARACIÓN DE OTROS EQUIPOS DE TRANSPORTE N.C.P., EXCEPTO VEHÍCULOS AUTOMOTORES', '331900, REPARACIÓN DE OTROS TIPOS DE EQUIPO']
}, {
  nombre: 'INSTALACIÓN DE MAQUINARIA Y EQUIPOS INDUSTRIALES',
  giros: ['332000, INSTALACIÓN DE MAQUINARIA Y EQUIPOS INDUSTRIALES']
}, {
  nombre: 'GENERACIÓN',
  giros: ['351011, GENERACIÓN DE ENERGÍA ELÉCTRICA EN CENTRALES HIDROELÉCTRICAS', '351012, GENERACIÓN DE ENERGÍA ELÉCTRICA EN CENTRALES TERMOELÉCTRICAS', '351019, GENERACIÓN DE ENERGÍA ELÉCTRICA EN OTRAS CENTRALES N.C.P.', '351020, TRANSMISIÓN DE ENERGÍA ELÉCTRICA', '351030, DISTRIBUCIÓN DE ENERGÍA ELÉCTRICA']
}, {
  nombre: 'FABRICACIÓN DE GAS; DISTRIBUCIÓN DE COMBUSTIBLES GASEOSOS POR TUBERÍAS',
  giros: ['352010, REGASIFICACIÓN DE GAS NATURAL LICUADO (GNL)', '352020, FABRICACIÓN DE GAS; DISTRIBUCIÓN DE COMBUSTIBLES GASEOSOS POR TUBERÍA, EXCEPTO REGASIFICACIÓN DE GNL']
}, {
  nombre: 'SUMINISTRO DE VAPOR Y DE AIRE ACONDICIONADO',
  giros: ['353001, SUMINISTRO DE VAPOR Y DE AIRE ACONDICIONADO', '353002, ELABORACIÓN DE HIELO (EXCEPTO FABRICACIÓN DE HIELO SECO)']
}, {
  nombre: 'CAPTACIÓN',
  giros: ['360000, CAPTACIÓN, TRATAMIENTO Y DISTRIBUCIÓN DE AGUA']
}, {
  nombre: 'EVACUACIÓN DE AGUAS RESIDUALES',
  giros: ['370000, EVACUACIÓN Y TRATAMIENTO DE AGUAS SERVIDAS']
}, {
  nombre: 'RECOGIDA DE DESECHOS',
  giros: ['381100, RECOGIDA DE DESECHOS NO PELIGROSOS', '381200, RECOGIDA DE DESECHOS PELIGROSOS']
}, {
  nombre: 'TRATAMIENTO Y ELIMINACIÓN DE DESECHOS',
  giros: ['382100, TRATAMIENTO Y ELIMINACIÓN DE DESECHOS NO PELIGROSOS', '382200, TRATAMIENTO Y ELIMINACIÓN DE DESECHOS PELIGROSOS']
}, {
  nombre: 'RECUPERACIÓN DE MATERIALES',
  giros: ['383001, RECUPERACIÓN Y RECICLAMIENTO DE DESPERDICIOS Y DESECHOS METÁLICOS', '383002, RECUPERACIÓN Y RECICLAMIENTO DE PAPEL', '383003, RECUPERACIÓN Y RECICLAMIENTO DE VIDRIO', '383009, RECUPERACIÓN Y RECICLAMIENTO DE OTROS DESPERDICIOS Y DESECHOS N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE DESCONTAMINACIÓN Y OTROS SERVICIOS DE GESTIÓN DE DESECHOS',
  giros: ['390000, ACTIVIDADES DE DESCONTAMINACIÓN Y OTROS SERVICIOS DE GESTIÓN DE DESECHOS']
}, {
  nombre: 'CONSTRUCCIÓN DE EDIFICIOS',
  giros: ['410010, CONSTRUCCIÓN DE EDIFICIOS PARA USO RESIDENCIAL', '410020, CONSTRUCCIÓN DE EDIFICIOS PARA USO NO RESIDENCIAL']
}, {
  nombre: 'CONSTRUCCIÓN DE CARRETERAS Y LÍNEAS DE FERROCARRIL',
  giros: ['421000, CONSTRUCCIÓN DE CARRETERAS Y LÍNEAS DE FERROCARRIL']
}, {
  nombre: 'CONSTRUCCIÓN DE PROYECTOS DE SERVICIO PÚBLICO',
  giros: ['422000, CONSTRUCCIÓN DE PROYECTOS DE SERVICIO PÚBLICO']
}, {
  nombre: 'CONSTRUCCIÓN DE OTRAS OBRAS DE INGENIERÍA CIVIL',
  giros: ['429000, CONSTRUCCIÓN DE OTRAS OBRAS DE INGENIERÍA CIVIL']
}, {
  nombre: 'DEMOLICIÓN Y PREPARACIÓN DEL TERRENO',
  giros: ['431100, DEMOLICIÓN', '431200, PREPARACIÓN DEL TERRENO']
}, {
  nombre: 'INSTALACIONES ELÉCTRICAS',
  giros: ['432100, INSTALACIONES ELÉCTRICAS', '432200, INSTALACIONES DE GASFITERÍA, CALEFACCIÓN Y AIRE ACONDICIONADO', '432900, OTRAS INSTALACIONES PARA OBRAS DE CONSTRUCCIÓN']
}, {
  nombre: 'TERMINACIÓN Y ACABADO DE EDIFICIOS',
  giros: ['433000, TERMINACIÓN Y ACABADO DE EDIFICIOS']
}, {
  nombre: 'OTRAS ACTIVIDADES ESPECIALIZADAS DE CONSTRUCCIÓN',
  giros: ['439000, OTRAS ACTIVIDADES ESPECIALIZADAS DE CONSTRUCCIÓN']
}, {
  nombre: 'VENTA DE VEHÍCULOS AUTOMOTORES',
  giros: ['451001, VENTA AL POR MAYOR DE VEHÍCULOS AUTOMOTORES', '451002, VENTA AL POR MENOR DE VEHÍCULOS AUTOMOTORES NUEVOS O USADOS (INCLUYE COMPRAVENTA)']
}, {
  nombre: 'MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS AUTOMOTORES',
  giros: ['452001, SERVICIO DE LAVADO DE VEHÍCULOS AUTOMOTORES', '452002, MANTENIMIENTO Y REPARACIÓN DE VEHÍCULOS AUTOMOTORES']
}, {
  nombre: 'VENTA DE PARTES',
  giros: ['453000, VENTA DE PARTES, PIEZAS Y ACCESORIOS PARA VEHÍCULOS AUTOMOTORES']
}, {
  nombre: 'VENTA',
  giros: ['454001, VENTA DE MOTOCICLETAS', '454002, VENTA DE PARTES, PIEZAS Y ACCESORIOS DE MOTOCICLETAS', '454003, MANTENIMIENTO Y REPARACIÓN DE MOTOCICLETAS']
}, {
  nombre: 'VENTA AL POR MAYOR A CAMBIO DE UNA RETRIBUCIÓN O POR CONTRATA',
  giros: ['461001, CORRETAJE AL POR MAYOR DE PRODUCTOS AGRÍCOLAS', '461002, CORRETAJE AL POR MAYOR DE GANADO', '461009, OTROS TIPOS DE CORRETAJES O REMATES AL POR MAYOR N.C.P.']
}, {
  nombre: 'VENTA AL POR MAYOR DE MATERIAS PRIMAS AGROPECUARIAS Y ANIMALES VIVOS',
  giros: ['462010, VENTA AL POR MAYOR DE MATERIAS PRIMAS AGRÍCOLAS', '462020, VENTA AL POR MAYOR DE ANIMALES VIVOS', '462090, VENTA AL POR MAYOR DE OTRAS MATERIAS PRIMAS AGROPECUARIAS N.C.P.']
}, {
  nombre: 'VENTA AL POR MAYOR DE ALIMENTOS',
  giros: ['463011, VENTA AL POR MAYOR DE FRUTAS Y VERDURAS', '463012, VENTA AL POR MAYOR DE CARNE Y PRODUCTOS CÁRNICOS', '463013, VENTA AL POR MAYOR DE PRODUCTOS DEL MAR (PESCADOS, MARISCOS Y ALGAS)', '463014, VENTA AL POR MAYOR DE PRODUCTOS DE CONFITERÍA', '463019, VENTA AL POR MAYOR DE HUEVOS, LÁCTEOS, ABARROTES Y DE OTROS ALIMENTOS N.C.P.', '463020, VENTA AL POR MAYOR DE BEBIDAS ALCOHÓLICAS Y NO ALCOHÓLICAS', '463030, VENTA AL POR MAYOR DE TABACO']
}, {
  nombre: 'VENTA AL POR MAYOR DE ENSERES DOMÉSTICOS',
  giros: ['464100, VENTA AL POR MAYOR DE PRODUCTOS TEXTILES, PRENDAS DE VESTIR Y CALZADO', '464901, VENTA AL POR MAYOR DE MUEBLES, EXCEPTO MUEBLES DE OFICINA', '464902, VENTA AL POR MAYOR DE ARTÍCULOS ELÉCTRICOS Y ELECTRÓNICOS PARA EL HOGAR', '464903, VENTA AL POR MAYOR DE ARTÍCULOS DE PERFUMERÍA, DE TOCADOR Y COSMÉTICOS', '464904, VENTA AL POR MAYOR DE ARTÍCULOS DE PAPELERÍA Y ESCRITORIO', '464905, VENTA AL POR MAYOR DE LIBROS', '464906, VENTA AL POR MAYOR DE DIARIOS Y REVISTAS', '464907, VENTA AL POR MAYOR DE PRODUCTOS FARMACÉUTICOS Y MEDICINALES', '464908, VENTA AL POR MAYOR DE INSTRUMENTOS CIENTÍFICOS Y QUIRÚRGICOS', '464909, VENTA AL POR MAYOR DE OTROS ENSERES DOMÉSTICOS N.C.P.']
}, {
  nombre: 'VENTA AL POR MAYOR DE MAQUINARIA',
  giros: ['465100, VENTA AL POR MAYOR DE COMPUTADORES, EQUIPO PERIFÉRICO Y PROGRAMAS INFORMÁTICOS', '465200, VENTA AL POR MAYOR DE EQUIPO, PARTES Y PIEZAS ELECTRÓNICOS Y DE TELECOMUNICACIONES', '465300, VENTA AL POR MAYOR DE MAQUINARIA, EQUIPO Y MATERIALES AGROPECUARIOS', '465901, VENTA AL POR MAYOR DE MAQUINARIA METALÚRGICA, PARA LA MINERÍA, EXTRACCIÓN DE PETRÓLEO Y CONSTRUCCIÓN', '465902, VENTA AL POR MAYOR DE MAQUINARIA PARA LA ELABORACIÓN DE ALIMENTOS, BEBIDAS Y TABACO', '465903, VENTA AL POR MAYOR DE MAQUINARIA PARA LA INDUSTRIA TEXTIL, DEL CUERO Y DEL CALZADO', '465904, VENTA AL POR MAYOR DE MAQUINARIA Y EQUIPO DE OFICINA; VENTA AL POR MAYOR DE MUEBLES DE OFICINA', '465905, VENTA AL POR MAYOR DE EQUIPO DE TRANSPORTE(EXCEPTO VEHÍCULOS AUTOMOTORES, MOTOCICLETAS Y BICICLETAS)', '465909, VENTA AL POR MAYOR DE OTROS TIPOS DE MAQUINARIA Y EQUIPO N.C.P.']
}, {
  nombre: 'OTRAS ACTIVIDADES DE VENTA AL POR MAYOR ESPECIALIZADA',
  giros: ['466100, VENTA AL POR MAYOR DE COMBUSTIBLES SÓLIDOS, LÍQUIDOS Y GASEOSOS Y PRODUCTOS CONEXOS', '466200, VENTA AL POR MAYOR DE METALES Y MINERALES METALÍFEROS', '466301, VENTA AL POR MAYOR DE MADERA EN BRUTO Y PRODUCTOS PRIMARIOS DE LA ELABORACIÓN DE MADERA', '466302, VENTA AL POR MAYOR DE MATERIALES DE CONSTRUCCIÓN, ARTÍCULOS DE FERRETERÍA, GASFITERÍA Y CALEFACCIÓN', '466901, VENTA AL POR MAYOR DE PRODUCTOS QUÍMICOS', '466902, VENTA AL POR MAYOR DE DESECHOS METÁLICOS (CHATARRA)', '466909, VENTA AL POR MAYOR DE DESPERDICIOS, DESECHOS Y OTROS PRODUCTOS N.C.P.']
}, {
  nombre: 'VENTA AL POR MAYOR NO ESPECIALIZADA',
  giros: ['469000, VENTA AL POR MAYOR NO ESPECIALIZADA']
}, {
  nombre: 'VENTA AL POR MENOR EN COMERCIOS NO ESPECIALIZADOS',
  giros: ['471100, VENTA AL POR MENOR EN COMERCIOS DE ALIMENTOS, BEBIDAS O TABACO (SUPERMERCADOS E HIPERMERCADOS)', '471910, VENTA AL POR MENOR EN COMERCIOS DE VESTUARIO Y PRODUCTOS PARA EL HOGAR (GRANDES TIENDAS)', '471990, OTRAS ACTIVIDADES DE VENTA AL POR MENOR EN COMERCIOS NO ESPECIALIZADOS N.C.P.']
}, {
  nombre: 'VENTA AL POR MENOR DE ALIMENTOS',
  giros: ['472101, VENTA AL POR MENOR DE ALIMENTOS EN COMERCIOS ESPECIALIZADOS (ALMACENES PEQUEÑOS Y MINIMARKET)', '472102, VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE CARNE Y PRODUCTOS CÁRNICOS', '472103, VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE FRUTAS Y VERDURAS (VERDULERÍAS)', '472104, VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE PESCADO, MARISCOS Y PRODUCTOS CONEXOS', '472105, VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE PRODUCTOS DE PANADERÍA Y PASTELERÍA', '472109, VENTA AL POR MENOR EN COMERCIOS ESPECIALIZADOS DE HUEVOS, CONFITES Y PRODUCTOS ALIMENTICIOS N.C.P.', '472200, VENTA AL POR MENOR DE BEBIDAS ALCOHÓLICAS Y NO ALCOHÓLICAS EN COMERCIOS ESPECIALIZADOS (BOTILLERÍAS)', '472300, VENTA AL POR MENOR DE TABACO Y PRODUCTOS DE TABACO EN COMERCIOS ESPECIALIZADOS']
}, {
  nombre: 'VENTA AL POR MENOR DE COMBUSTIBLES PARA VEHÍCULOS AUTOMOTORES EN COMERCIOS ESPECIALIZADOS',
  giros: ['473000, VENTA AL POR MENOR DE COMBUSTIBLES PARA VEHÍCULOS AUTOMOTORES EN COMERCIOS ESPECIALIZADOS', '474100, VENTA AL POR MENOR DE COMPUTADORES, EQUIPO PERIFÉRICO, PROGRAMAS INFORMÁTICOS Y EQUIPO DE TELECOM.', '474200, VENTA AL POR MENOR DE EQUIPO DE SONIDO Y DE VIDEO EN COMERCIOS ESPECIALIZADOS']
}, {
  nombre: 'VENTA AL POR MENOR DE OTROS ENSERES DOMÉSTICOS EN COMERCIOS ESPECIALIZADOS',
  giros: ['475100, VENTA AL POR MENOR DE TELAS, LANAS, HILOS Y SIMILARES EN COMERCIOS ESPECIALIZADOS', '475201, VENTA AL POR MENOR DE ARTÍCULOS DE FERRETERÍA Y MATERIALES DE CONSTRUCCIÓN', '475202, VENTA AL POR MENOR DE PINTURAS, BARNICES Y LACAS EN COMERCIOS ESPECIALIZADOS', '475203, VENTA AL POR MENOR DE PRODUCTOS DE VIDRIO EN COMERCIOS ESPECIALIZADOS', '475300, VENTA AL POR MENOR DE TAPICES, ALFOMBRAS Y CUBRIMIENTOS PARA PAREDES Y PISOS', '475901, VENTA AL POR MENOR DE MUEBLES Y COLCHONES EN COMERCIOS ESPECIALIZADOS', '475902, VENTA AL POR MENOR DE INSTRUMENTOS MUSICALES EN COMERCIOS ESPECIALIZADOS', '475909, VENTA AL POR MENOR DE APARATOS ELÉCTRICOS, TEXTILES PARA EL HOGAR Y OTROS ENSERES DOMÉSTICOS N.C.P.']
}, {
  nombre: 'VENTA AL POR MENOR DE PRODUCTOS CULTURALES Y RECREATIVOS EN COMERCIOS ESPECIALIZADOS',
  giros: ['476101, VENTA AL POR MENOR DE LIBROS EN COMERCIOS ESPECIALIZADOS', '476102, VENTA AL POR MENOR DE DIARIOS Y REVISTAS EN COMERCIOS ESPECIALIZADOS', '476103, VENTA AL POR MENOR DE ARTÍCULOS DE PAPELERÍA Y ESCRITORIO EN COMERCIOS ESPECIALIZADOS', '476200, VENTA AL POR MENOR DE GRABACIONES DE MÚSICA Y DE VIDEO EN COMERCIOS ESPECIALIZADOS', '476301, VENTA AL POR MENOR DE ARTÍCULOS DE CAZA Y PESCA EN COMERCIOS ESPECIALIZADOS', '476302, VENTA AL POR MENOR DE BICICLETAS Y SUS REPUESTOS EN COMERCIOS ESPECIALIZADOS', '476309, VENTA AL POR MENOR DE OTROS ARTÍCULOS Y EQUIPOS DE DEPORTE N.C.P.', '476400, VENTA AL POR MENOR DE JUEGOS Y JUGUETES EN COMERCIOS ESPECIALIZADOS']
}, {
  nombre: 'VENTA AL POR MENOR DE OTROS PRODUCTOS EN COMERCIOS ESPECIALIZADOS',
  giros: ['477101, VENTA AL POR MENOR DE CALZADO EN COMERCIOS ESPECIALIZADOS', '477102, VENTA AL POR MENOR DE PRENDAS Y ACCESORIOS DE VESTIR EN COMERCIOS ESPECIALIZADOS', '477103, VENTA AL POR MENOR DE CARTERAS, MALETAS Y OTROS ACCESORIOS DE VIAJE EN COMERCIOS ESPECIALIZADOS', '477201, VENTA AL POR MENOR DE PRODUCTOS FARMACÉUTICOS Y MEDICINALES EN COMERCIOS ESPECIALIZADOS', '477202, VENTA AL POR MENOR DE ARTÍCULOS ORTOPÉDICOS EN COMERCIOS ESPECIALIZADOS', '477203, VENTA AL POR MENOR DE ARTÍCULOS DE PERFUMERÍA, DE TOCADOR Y COSMÉTICOS EN COMERCIOS ESPECIALIZADOS', '477310, VENTA AL POR MENOR DE GAS LICUADO EN BOMBONAS (CILINDROS) EN COMERCIOS ESPECIALIZADOS', '477391, VENTA AL POR MENOR DE ALIMENTO Y ACCESORIOS PARA MASCOTAS EN COMERCIOS ESPECIALIZADOS', '477392, VENTA AL POR MENOR DE ARMAS Y MUNICIONES EN COMERCIOS ESPECIALIZADOS', '477393, VENTA AL POR MENOR DE ARTÍCULOS ÓPTICOS EN COMERCIOS ESPECIALIZADOS', '477394, VENTA AL POR MENOR DE ARTÍCULOS DE JOYERÍA, BISUTERÍA Y RELOJERÍA EN COMERCIOS ESPECIALIZADOS', '477395, VENTA AL POR MENOR DE CARBÓN, LEÑA Y OTROS COMBUSTIBLES DE USO DOMÉSTICO EN COMERCIOS ESPECIALIZADOS', '477396, VENTA AL POR MENOR DE RECUERDOS, ARTESANÍAS Y ARTÍCULOS RELIGIOSOS EN COMERCIOS ESPECIALIZADOS', '477397, VENTA AL POR MENOR DE FLORES, PLANTAS, ARBOLES, SEMILLAS Y ABONOS EN COMERCIOS ESPECIALIZADOS', '477398, VENTA AL POR MENOR DE MASCOTAS EN COMERCIOS ESPECIALIZADOS', '477399, VENTA AL POR MENOR DE OTROS PRODUCTOS EN COMERCIOS ESPECIALIZADOS N.C.P.', '477401, VENTA AL POR MENOR DE ANTIGÜEDADES EN COMERCIOS', '477402, VENTA AL POR MENOR DE ROPA USADA EN COMERCIOS', '477409, VENTA AL POR MENOR DE OTROS ARTÍCULOS DE SEGUNDA MANO EN COMERCIOS N.C.P.']
}, {
  nombre: 'VENTA AL POR MENOR EN PUESTOS DE VENTA Y MERCADOS',
  giros: ['478100, VENTA AL POR MENOR DE ALIMENTOS, BEBIDAS Y TABACO EN PUESTOS DE VENTA Y MERCADOS (INCLUYE FERIAS)', '478200, VENTA AL POR MENOR DE PRODUCTOS TEXTILES, PRENDAS DE VESTIR Y CALZADO EN PUESTOS DE VENTA Y MERCADOS', '478900, VENTA AL POR MENOR DE OTROS PRODUCTOS EN PUESTOS DE VENTA Y MERCADOS (INCLUYE FERIAS)']
}, {
  nombre: 'VENTA AL POR MENOR NO REALIZADA EN COMERCIOS',
  giros: ['479100, VENTA AL POR MENOR POR CORREO, POR INTERNET Y VÍA TELEFÓNICA', '479901, VENTA AL POR MENOR REALIZADA POR INDEPENDIENTES EN LA LOCOMOCIÓN COLECTIVA (LEY 20.388)', '479902, VENTA AL POR MENOR MEDIANTE MAQUINAS EXPENDEDORAS', '479903, VENTA AL POR MENOR POR COMISIONISTAS (NO DEPENDIENTES DE COMERCIOS)', '479909, OTRAS ACTIVIDADES DE VENTA POR MENOR NO REALIZADAS EN COMERCIOS, PUESTOS DE VENTA O MERCADOS N.C.P.']
}, {
  nombre: 'TRANSPORTE POR FERROCARRIL',
  giros: ['491100, TRANSPORTE INTERURBANO DE PASAJEROS POR FERROCARRIL', '491200, TRANSPORTE DE CARGA POR FERROCARRIL']
}, {
  nombre: 'OTRAS ACTIVIDADES DE TRANSPORTE POR VÍA TERRESTRE',
  giros: ['492110, TRANSPORTE URBANO Y SUBURBANO DE PASAJEROS VÍA METRO Y METROTREN', '492120, TRANSPORTE URBANO Y SUBURBANO DE PASAJEROS VÍA LOCOMOCIÓN COLECTIVA', '492130, TRANSPORTE DE PASAJEROS VÍA TAXI COLECTIVO', '492190, OTRAS ACTIVIDADES DE TRANSPORTE URBANO Y SUBURBANO DE PASAJEROS POR VÍA TERRESTRE N.C.P.', '492210, SERVICIOS DE TRANSPORTE DE ESCOLARES', '492220, SERVICIOS DE TRANSPORTE DE TRABAJADORES', '492230, SERVICIOS DE TRANSPORTE DE PASAJEROS EN TAXIS LIBRES Y RADIOTAXIS', '492240, SERVICIOS DE TRANSPORTE A TURISTAS', '492250, TRANSPORTE DE PASAJEROS EN BUSES INTERURBANOS', '492290, OTRAS ACTIVIDADES DE TRANSPORTE DE PASAJEROS POR VÍA TERRESTRE N.C.P.', '492300, TRANSPORTE DE CARGA POR CARRETERA']
}, {
  nombre: 'TRANSPORTE POR TUBERÍAS',
  giros: ['493010, TRANSPORTE POR OLEODUCTOS', '493020, TRANSPORTE POR GASODUCTOS', '493090, OTRAS ACTIVIDADES DE TRANSPORTE POR TUBERÍAS N.C.P.']
}, {
  nombre: 'TRANSPORTE MARÍTIMO Y DE CABOTAJE',
  giros: ['501100, TRANSPORTE DE PASAJEROS MARÍTIMO Y DE CABOTAJE', '501200, TRANSPORTE DE CARGA MARÍTIMO Y DE CABOTAJE']
}, {
  nombre: 'TRANSPORTE POR VÍAS DE NAVEGACIÓN INTERIORES',
  giros: ['502100, TRANSPORTE DE PASAJEROS POR VÍAS DE NAVEGACIÓN INTERIORES', '502200, TRANSPORTE DE CARGA POR VÍAS DE NAVEGACIÓN INTERIORES']
}, {
  nombre: 'TRANSPORTE DE PASAJEROS POR VÍA AÉREA',
  giros: ['511000, TRANSPORTE DE PASAJEROS POR VÍA AÉREA']
}, {
  nombre: 'TRANSPORTE DE CARGA POR VÍA AÉREA',
  giros: ['512000, TRANSPORTE DE CARGA POR VÍA AÉREA']
}, {
  nombre: 'ALMACENAMIENTO Y DEPÓSITO',
  giros: ['521001, EXPLOTACIÓN DE FRIGORÍFICOS PARA ALMACENAMIENTO Y DEPÓSITO', '521009, OTROS SERVICIOS DE ALMACENAMIENTO Y DEPÓSITO N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE APOYO AL TRANSPORTE',
  giros: ['522110, EXPLOTACIÓN DE TERMINALES TERRESTRES DE PASAJEROS', '522120, EXPLOTACIÓN DE ESTACIONAMIENTOS DE VEHÍCULOS AUTOMOTORES Y PARQUÍMETROS', '522130, SERVICIOS PRESTADOS POR CONCESIONARIOS DE CARRETERAS', '522190, ACTIVIDADES DE SERVICIOS VINCULADAS AL TRANSPORTE TERRESTRE N.C.P.', '522200, ACTIVIDADES DE SERVICIOS VINCULADAS AL TRANSPORTE ACUÁTICO', '522300, ACTIVIDADES DE SERVICIOS VINCULADAS AL TRANSPORTE AÉREO', '522400, MANIPULACIÓN DE LA CARGA', '522910, AGENCIAS DE ADUANAS', '522920, AGENCIAS DE NAVES', '522990, OTRAS ACTIVIDADES DE APOYO AL TRANSPORTE N.C.P.']
}, {
  nombre: 'ACTIVIDADES POSTALES',
  giros: ['531000, ACTIVIDADES POSTALES']
}, {
  nombre: 'ACTIVIDADES DE MENSAJERÍA',
  giros: ['532000, ACTIVIDADES DE MENSAJERÍA']
}, {
  nombre: 'ACTIVIDADES DE ALOJAMIENTO PARA ESTANCIAS CORTAS',
  giros: ['551001, ACTIVIDADES DE HOTELES', '551002, ACTIVIDADES DE MOTELES', '551003, ACTIVIDADES DE RESIDENCIALES PARA TURISTAS', '551009, OTRAS ACTIVIDADES DE ALOJAMIENTO PARA TURISTAS N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE CAMPAMENTOS',
  giros: ['552000, ACTIVIDADES DE CAMPING Y DE PARQUES PARA CASAS RODANTES']
}, {
  nombre: 'OTRAS ACTIVIDADES DE ALOJAMIENTO',
  giros: ['559001, ACTIVIDADES DE RESIDENCIALES PARA ESTUDIANTES Y TRABAJADORES', '559009, OTRAS ACTIVIDADES DE ALOJAMIENTO N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE RESTAURANTES Y DE SERVICIO MÓVIL DE COMIDAS',
  giros: ['561000, ACTIVIDADES DE RESTAURANTES Y DE SERVICIO MÓVIL DE COMIDAS']
}, {
  nombre: 'SUMINISTRO DE COMIDAS POR ENCARGO Y OTRAS ACTIVIDADES DE SERVICIO DE COMIDAS',
  giros: ['562100, SUMINISTRO DE COMIDAS POR ENCARGO (SERVICIOS DE BANQUETERÍA)', '562900, SUMINISTRO INDUSTRIAL DE COMIDAS POR ENCARGO; CONCESIÓN DE SERVICIOS DE ALIMENTACIÓN']
}, {
  nombre: 'ACTIVIDADES DE SERVICIO DE BEBIDAS',
  giros: ['563001, ACTIVIDADES DE DISCOTECAS Y CABARET (NIGHT CLUB), CON PREDOMINIO DEL SERVICIO DE BEBIDAS', '563009, OTRAS ACTIVIDADES DE SERVICIO DE BEBIDAS N.C.P.']
}, {
  nombre: 'EDICIÓN DE LIBROS Y PUBLICACIONES PERIÓDICAS Y OTRAS ACTIVIDADES DE EDICIÓN',
  giros: ['581100, EDICIÓN DE LIBROS', '581200, EDICIÓN DE DIRECTORIOS Y LISTAS DE CORREO', '581300, EDICIÓN DE DIARIOS, REVISTAS Y OTRAS PUBLICACIONES PERIÓDICAS', '581900, OTRAS ACTIVIDADES DE EDICIÓN']
}, {
  nombre: 'EDICIÓN DE PROGRAMAS INFORMÁTICOS',
  giros: ['582000, EDICIÓN DE PROGRAMAS INFORMÁTICOS']
}, {
  nombre: 'ACTIVIDADES DE PRODUCCIÓN DE PELÍCULAS CINEMATOGRÁFICAS',
  giros: ['591100, ACTIVIDADES DE PRODUCCIÓN DE PELÍCULAS CINEMATOGRÁFICAS, VIDEOS Y PROGRAMAS DE TELEVISIÓN', '591200, ACTIVIDADES DE POSTPRODUCCIÓN DE PELÍCULAS CINEMATOGRÁFICAS, VIDEOS Y PROGRAMAS DE TELEVISIÓN', '591300, ACTIVIDADES DE DISTRIBUCIÓN DE PELÍCULAS CINEMATOGRÁFICAS, VIDEOS Y PROGRAMAS DE TELEVISIÓN', '591400, ACTIVIDADES DE EXHIBICIÓN DE PELÍCULAS CINEMATOGRÁFICAS Y CINTAS DE VIDEO']
}, {
  nombre: 'ACTIVIDADES DE GRABACIÓN DE SONIDO Y EDICIÓN DE MÚSICA',
  giros: ['592000, ACTIVIDADES DE GRABACIÓN DE SONIDO Y EDICIÓN DE MÚSICA']
}, {
  nombre: 'TRANSMISIONES DE RADIO',
  giros: ['601000, TRANSMISIONES DE RADIO']
}, {
  nombre: 'PROGRAMACIÓN Y TRANSMISIONES DE TELEVISIÓN',
  giros: ['602000, PROGRAMACIÓN Y TRANSMISIONES DE TELEVISIÓN']
}, {
  nombre: 'ACTIVIDADES DE TELECOMUNICACIONES ALÁMBRICAS',
  giros: ['611010, TELEFONÍA FIJA', '611020, TELEFONÍA LARGA DISTANCIA', '611030, TELEVISIÓN DE PAGO POR CABLE', '611090, OTROS SERVICIOS DE TELECOMUNICACIONES ALÁMBRICAS N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE TELECOMUNICACIONES INALÁMBRICAS',
  giros: ['612010, TELEFONÍA MÓVIL CELULAR', '612020, RADIOCOMUNICACIONES MÓVILES', '612030, TELEVISIÓN DE PAGO INALÁMBRICA', '612090, OTROS SERVICIOS DE TELECOMUNICACIONES INALÁMBRICAS N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE TELECOMUNICACIONES POR SATÉLITE',
  giros: ['613010, TELEFONÍA MÓVIL SATELITAL', '613020, TELEVISIÓN DE PAGO SATELITAL', '613090, OTROS SERVICIOS DE TELECOMUNICACIONES POR SATÉLITE N.C.P.']
}, {
  nombre: 'OTRAS ACTIVIDADES DE TELECOMUNICACIONES',
  giros: ['619010, CENTROS DE LLAMADOS Y CENTROS DE ACCESO A INTERNET', '619090, OTRAS ACTIVIDADES DE TELECOMUNICACIONES N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE PROGRAMACIÓN INFORMÁTICA',
  giros: ['620100, ACTIVIDADES DE PROGRAMACIÓN INFORMÁTICA', '620200, ACTIVIDADES DE CONSULTORÍA DE INFORMÁTICA Y DE GESTIÓN DE INSTALACIONES INFORMÁTICAS', '620900, OTRAS ACTIVIDADES DE TECNOLOGÍA DE LA INFORMACIÓN Y DE SERVICIOS INFORMÁTICOS']
}, {
  nombre: 'PROCESAMIENTO DE DATOS',
  giros: ['631100, PROCESAMIENTO DE DATOS, HOSPEDAJE Y ACTIVIDADES CONEXAS', '631200, PORTALES WEB']
}, {
  nombre: 'OTRAS ACTIVIDADES DE SERVICIOS DE INFORMACIÓN',
  giros: ['639100, ACTIVIDADES DE AGENCIAS DE NOTICIAS', '639900, OTRAS ACTIVIDADES DE SERVICIOS DE INFORMACIÓN N.C.P.']
}, {
  nombre: 'INTERMEDIACIÓN MONETARIA',
  giros: ['641100, BANCA CENTRAL', '641910, ACTIVIDADES BANCARIAS', '641990, OTROS TIPOS DE INTERMEDIACIÓN MONETARIA N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE SOCIEDADES DE CARTERA',
  giros: ['642000, ACTIVIDADES DE SOCIEDADES DE CARTERA']
}, {
  nombre: 'FONDOS Y SOCIEDADES DE INVERSIÓN Y ENTIDADES FINANCIERAS SIMILARES',
  giros: ['643000, FONDOS Y SOCIEDADES DE INVERSIÓN Y ENTIDADES FINANCIERAS SIMILARES']
}, {
  nombre: 'OTRAS ACTIVIDADES DE SERVICIOS FINANCIEROS',
  giros: ['649100, LEASING FINANCIERO', '649201, FINANCIERAS', '649202, ACTIVIDADES DE CRÉDITO PRENDARIO', '649203, CAJAS DE COMPENSACIÓN', '649209, OTRAS ACTIVIDADES DE CONCESIÓN DE CRÉDITO N.C.P.', '649900, OTRAS ACTIVIDADES DE SERVICIOS FINANCIEROS, EXCEPTO LAS DE SEGUROS Y FONDOS DE PENSIONES N.C.P.']
}, {
  nombre: 'SEGUROS',
  giros: ['651100, SEGUROS DE VIDA', '651210, SEGUROS GENERALES, EXCEPTO ACTIVIDADES DE ISAPRES', '651220, ACTIVIDADES DE ISAPRES']
}, {
  nombre: 'REASEGUROS',
  giros: ['652000, REASEGUROS']
}, {
  nombre: 'FONDOS DE PENSIONES',
  giros: ['653000, FONDOS DE PENSIONES']
}, {
  nombre: 'ACTIVIDADES AUXILIARES DE SERVICIOS FINANCIEROS',
  giros: ['661100, ADMINISTRACIÓN DE MERCADOS FINANCIEROS', '661201, ACTIVIDADES DE SECURITIZADORAS', '661202, CORREDORES DE BOLSA', '661203, AGENTES DE VALORES', '661204, ACTIVIDADES DE CASAS DE CAMBIO Y OPERADORES DE DIVISA', '661209, OTROS SERVICIOS DE CORRETAJE DE VALORES Y COMMODITIES N.C.P.', '661901, ACTIVIDADES DE CÁMARAS DE COMPENSACIÓN', '661902, ADMINISTRACIÓN DE TARJETAS DE CRÉDITO', '661903, EMPRESAS DE ASESORÍA Y CONSULTORÍA EN INVERSIÓN FINANCIERA; SOCIEDADES DE APOYO AL GIRO', '661904, ACTIVIDADES DE CLASIFICADORAS DE RIESGO', '661909, OTRAS ACTIVIDADES AUXILIARES DE LAS ACTIVIDADES DE SERVICIOS FINANCIEROS N.C.P.']
}, {
  nombre: 'ACTIVIDADES AUXILIARES DE LAS ACTIVIDADES DE SEGUROS Y FONDOS DE PENSIONES',
  giros: ['662100, EVALUACIÓN DE RIESGOS Y DAÑOS (INCLUYE ACTIVIDADES DE LIQUIDADORES DE SEGUROS)', '662200, ACTIVIDADES DE AGENTES Y CORREDORES DE SEGUROS', '662900, OTRAS ACTIVIDADES AUXILIARES DE LAS ACTIVIDADES DE SEGUROS Y FONDOS DE PENSIONES']
}, {
  nombre: 'ACTIVIDADES DE GESTIÓN DE FONDOS',
  giros: ['663010, ADMINISTRADORAS DE FONDOS DE PENSIONES (AFP)', '663091, ADMINISTRADORAS DE FONDOS DE INVERSIÓN', '663092, ADMINISTRADORAS DE FONDOS MUTUOS', '663093, ADMINISTRADORAS DE FICES (FONDOS DE INVERSIÓN DE CAPITAL EXTRANJERO)', '663094, ADMINISTRADORAS DE FONDOS PARA LA VIVIENDA', '663099, ADMINISTRADORAS DE FONDOS PARA OTROS FINES N.C.P.']
}, {
  nombre: 'ACTIVIDADES INMOBILIARIAS REALIZADAS CON BIENES PROPIOS O ARRENDADOS',
  giros: ['681011, ALQUILER DE BIENES INMUEBLES AMOBLADOS O CON EQUIPOS Y MAQUINARIAS', '681012, COMPRA, VENTA Y ALQUILER (EXCEPTO AMOBLADOS) DE INMUEBLES', '681020, SERVICIOS IMPUTADOS DE ALQUILER DE VIVIENDAS']
}, {
  nombre: 'ACTIVIDADES INMOBILIARIAS REALIZADAS A CAMBIO DE UNA RETRIBUCIÓN O POR CONTRATA',
  giros: ['682000, ACTIVIDADES INMOBILIARIAS REALIZADAS A CAMBIO DE UNA RETRIBUCIÓN O POR CONTRATA']
}, {
  nombre: 'ACTIVIDADES JURÍDICAS',
  giros: ['691001, SERVICIOS DE ASESORAMIENTO Y REPRESENTACIÓN JURÍDICA', '691002, SERVICIO NOTARIAL', '691003, CONSERVADOR DE BIENES RAÍCES', '691004, RECEPTORES JUDICIALES', '691009, SERVICIOS DE ARBITRAJE; SÍNDICOS DE QUIEBRA Y PERITOS JUDICIALES; OTRAS ACTIVIDADES JURÍDICAS N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE CONTABILIDAD',
  giros: ['692000, ACTIVIDADES DE CONTABILIDAD, TENEDURÍA DE LIBROS Y AUDITORÍA; CONSULTORÍA FISCAL']
}, {
  nombre: 'ACTIVIDADES DE OFICINAS PRINCIPALES',
  giros: ['701000, ACTIVIDADES DE OFICINAS PRINCIPALES']
}, {
  nombre: 'ACTIVIDADES DE CONSULTORÍA DE GESTIÓN',
  giros: ['702000, ACTIVIDADES DE CONSULTORÍA DE GESTIÓN']
}, {
  nombre: 'ACTIVIDADES DE ARQUITECTURA E INGENIERÍA Y ACTIVIDADES CONEXAS DE CONSULTORÍA TÉCNICA',
  giros: ['711001, SERVICIOS DE ARQUITECTURA (DISEÑO DE EDIFICIOS, DIBUJO DE PLANOS DE CONSTRUCCIÓN, ENTRE OTROS)', '711002, EMPRESAS DE SERVICIOS DE INGENIERÍA Y ACTIVIDADES CONEXAS DE CONSULTORÍA TÉCNICA', '711003, SERVICIOS PROFESIONALES DE INGENIERÍA Y ACTIVIDADES CONEXAS DE CONSULTORÍA TÉCNICA']
}, {
  nombre: 'ENSAYOS Y ANÁLISIS TÉCNICOS',
  giros: ['712001, ACTIVIDADES DE PLANTAS DE REVISIÓN TÉCNICA PARA VEHÍCULOS AUTOMOTORES', '712009, OTROS SERVICIOS DE ENSAYOS Y ANÁLISIS TÉCNICOS (EXCEPTO ACTIVIDADES DE PLANTAS DE REVISIÓN TÉCNICA)']
}, {
  nombre: 'INVESTIGACIONES Y DESARROLLO EXPERIMENTAL EN EL CAMPO DE LAS CIENCIAS NATURALES Y LA INGENIERÍA',
  giros: ['721000, INVESTIGACIONES Y DESARROLLO EXPERIMENTAL EN EL CAMPO DE LAS CIENCIAS NATURALES Y LA INGENIERÍA']
}, {
  nombre: 'INVESTIGACIONES Y DESARROLLO EXPERIMENTAL EN EL CAMPO DE LAS CIENCIAS SOCIALES Y LAS HUMANIDADES',
  giros: ['722000, INVESTIGACIONES Y DESARROLLO EXPERIMENTAL EN EL CAMPO DE LAS CIENCIAS SOCIALES Y LAS HUMANIDADES']
}, {
  nombre: 'PUBLICIDAD',
  giros: ['731001, SERVICIOS DE PUBLICIDAD PRESTADOS POR EMPRESAS', '731002, SERVICIOS DE PUBLICIDAD PRESTADOS POR PROFESIONALES']
}, {
  nombre: 'ESTUDIOS DE MERCADO Y ENCUESTAS DE OPINIÓN PÚBLICA',
  giros: ['732000, ESTUDIOS DE MERCADO Y ENCUESTAS DE OPINIÓN PÚBLICA']
}, {
  nombre: 'ACTIVIDADES ESPECIALIZADAS DE DISEÑO',
  giros: ['741001, ACTIVIDADES DE DISEÑO DE VESTUARIO', '741002, ACTIVIDADES DE DISEÑO Y DECORACIÓN DE INTERIORES', '741009, OTRAS ACTIVIDADES ESPECIALIZADAS DE DISEÑO N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE FOTOGRAFÍA',
  giros: ['742001, SERVICIOS DE REVELADO, IMPRESIÓN Y AMPLIACIÓN DE FOTOGRAFÍAS', '742002, SERVICIOS Y ACTIVIDADES DE FOTOGRAFÍA', '742003, SERVICIOS PERSONALES DE FOTOGRAFÍA']
}, {
  nombre: 'OTRAS ACTIVIDADES PROFESIONALES',
  giros: ['749001, ASESORÍA Y GESTIÓN EN LA COMPRA O VENTA DE PEQUEÑAS Y MEDIANAS EMPRESAS', '749002, SERVICIOS DE TRADUCCIÓN E INTERPRETACIÓN PRESTADOS POR EMPRESAS', '749003, SERVICIOS PERSONALES DE TRADUCCIÓN E INTERPRETACIÓN', '749004, ACTIVIDADES DE AGENCIAS Y AGENTES DE REPRESENTACIÓN DE ACTORES, DEPORTISTAS Y OTRAS FIGURAS PÚBLICAS', '749009, OTRAS ACTIVIDADES PROFESIONALES, CIENTÍFICAS Y TÉCNICAS N.C.P.']
}, {
  nombre: 'ACTIVIDADES VETERINARIAS',
  giros: ['750001, ACTIVIDADES DE CLÍNICAS VETERINARIAS', '750002, ACTIVIDADES DE VETERINARIOS, TÉCNICOS Y OTRO PERSONAL AUXILIAR, PRESTADOS DE FORMA INDEPENDIENTE']
}, {
  nombre: 'ALQUILER Y ARRENDAMIENTO DE VEHÍCULOS AUTOMOTORES',
  giros: ['771000, ALQUILER DE VEHÍCULOS AUTOMOTORES SIN CHOFER']
}, {
  nombre: 'ALQUILER Y ARRENDAMIENTO DE EFECTOS PERSONALES Y ENSERES DOMÉSTICOS',
  giros: ['772100, ALQUILER Y ARRENDAMIENTO DE EQUIPO RECREATIVO Y DEPORTIVO', '772200, ALQUILER DE CINTAS DE VIDEO Y DISCOS', '772900, ALQUILER DE OTROS EFECTOS PERSONALES Y ENSERES DOMÉSTICOS (INCLUYE MOBILIARIO PARA EVENTOS)']
}, {
  nombre: 'ALQUILER Y ARRENDAMIENTO DE OTROS TIPOS DE MAQUINARIA',
  giros: ['773001, ALQUILER DE EQUIPOS DE TRANSPORTE SIN OPERARIO, EXCEPTO VEHÍCULOS AUTOMOTORES', '773002, ALQUILER DE MAQUINARIA Y EQUIPO AGROPECUARIO, FORESTAL, DE CONSTRUCCIÓN E ING. CIVIL, SIN OPERARIOS', '773003, ALQUILER DE MAQUINARIA Y EQUIPO DE OFICINA, SIN OPERARIOS (SIN SERVICIO ADMINISTRATIVO)', '773009, ALQUILER DE OTROS TIPOS DE MAQUINARIAS Y EQUIPOS SIN OPERARIO N.C.P.']
}, {
  nombre: 'ARRENDAMIENTO DE PROPIEDAD INTELECTUAL Y SIMILARES',
  giros: ['774000, ARRENDAMIENTO DE PROPIEDAD INTELECTUAL Y SIMILARES, EXCEPTO OBRAS PROTEGIDAS POR DERECHOS DE AUTOR']
}, {
  nombre: 'ACTIVIDADES DE AGENCIAS DE EMPLEO',
  giros: ['781000, ACTIVIDADES DE AGENCIAS DE EMPLEO']
}, {
  nombre: 'ACTIVIDADES DE AGENCIAS DE EMPLEO TEMPORAL',
  giros: ['782000, ACTIVIDADES DE AGENCIAS DE EMPLEO TEMPORAL (INCLUYE EMPRESAS DE SERVICIOS TRANSITORIOS)']
}, {
  nombre: 'OTRAS ACTIVIDADES DE DOTACIÓN DE RECURSOS HUMANOS',
  giros: ['783000, OTRAS ACTIVIDADES DE DOTACIÓN DE RECURSOS HUMANOS']
}, {
  nombre: 'ACTIVIDADES DE AGENCIAS DE VIAJES Y OPERADORES TURÍSTICOS',
  giros: ['791100, ACTIVIDADES DE AGENCIAS DE VIAJES', '791200, ACTIVIDADES DE OPERADORES TURÍSTICOS']
}, {
  nombre: 'OTROS SERVICIOS DE RESERVAS Y ACTIVIDADES CONEXAS',
  giros: ['799000, OTROS SERVICIOS DE RESERVAS Y ACTIVIDADES CONEXAS (INCLUYE VENTA DE ENTRADAS PARA TEATRO, Y OTROS)']
}, {
  nombre: 'ACTIVIDADES DE SEGURIDAD PRIVADA',
  giros: ['801001, SERVICIOS DE SEGURIDAD PRIVADA PRESTADOS POR EMPRESAS', '801002, SERVICIO DE TRANSPORTE DE VALORES EN VEHÍCULOS BLINDADOS', '801003, SERVICIOS DE SEGURIDAD PRIVADA PRESTADOS POR INDEPENDIENTES']
}, {
  nombre: 'ACTIVIDADES DE SERVICIOS DE SISTEMAS DE SEGURIDAD',
  giros: ['802000, ACTIVIDADES DE SERVICIOS DE SISTEMAS DE SEGURIDAD (INCLUYE SERVICIOS DE CERRAJERÍA)']
}, {
  nombre: 'ACTIVIDADES DE INVESTIGACIÓN',
  giros: ['803000, ACTIVIDADES DE INVESTIGACIÓN (INCLUYE ACTIVIDADES DE INVESTIGADORES Y DETECTIVES PRIVADOS)']
}, {
  nombre: 'ACTIVIDADES COMBINADAS DE APOYO A INSTALACIONES',
  giros: ['811000, ACTIVIDADES COMBINADAS DE APOYO A INSTALACIONES']
}, {
  nombre: 'ACTIVIDADES DE LIMPIEZA',
  giros: ['812100, LIMPIEZA GENERAL DE EDIFICIOS', '812901, DESRATIZACIÓN, DESINFECCIÓN Y EXTERMINIO DE PLAGAS NO AGRÍCOLAS', '812909, OTRAS ACTIVIDADES DE LIMPIEZA DE EDIFICIOS E INSTALACIONES INDUSTRIALES N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE PAISAJISMO Y SERVICIOS DE MANTENIMIENTO CONEXOS',
  giros: ['813000, ACTIVIDADES DE PAISAJISMO, SERVICIOS DE JARDINERÍA Y SERVICIOS CONEXOS']
}, {
  nombre: 'ACTIVIDADES ADMINISTRATIVAS Y DE APOYO DE OFICINA',
  giros: ['821900, FOTOCOPIADO, PREPARACIÓN DE DOCUMENTOS Y OTRAS ACTIVIDADES ESPECIALIZADAS DE APOYO DE OFICINA']
}, {
  nombre: 'ACTIVIDADES DE CALL-CENTER',
  giros: ['822000, ACTIVIDADES DE CALL-CENTER']
}, {
  nombre: 'ORGANIZACIÓN DE CONVENCIONES Y EXPOSICIONES COMERCIALES',
  giros: ['823000, ORGANIZACIÓN DE CONVENCIONES Y EXPOSICIONES COMERCIALES']
}, {
  nombre: 'ACTIVIDADES DE SERVICIOS DE APOYO A LAS EMPRESAS N.C.P.',
  giros: ['829110, ACTIVIDADES DE AGENCIAS DE COBRO', '829120, ACTIVIDADES DE AGENCIAS DE CALIFICACIÓN CREDITICIA', '829200, ACTIVIDADES DE ENVASADO Y EMPAQUETADO', '829900, OTRAS ACTIVIDADES DE SERVICIOS DE APOYO A LAS EMPRESAS N.C.P.']
}, {
  nombre: 'EXPLOTACIÓN DE BIENES INMUEBLES',
  giros: ['83101, ARRENDAMIENTO Y ADMINISTRACIÓN DE BIENES INMUEBLES', '83102, URBANIZACIÓN Y LOTEOS', '83103, CORREDORES DE PROPIEDADES']
}, {
  nombre: 'ADMINISTRACIÓN DEL ESTADO Y APLICACIÓN DE LA POLÍTICA ECONÓMICA Y SOCIAL DE LA COMUNIDAD',
  giros: ['841100, ACTIVIDADES DE LA ADMINISTRACIÓN PÚBLICA EN GENERAL', '841200, REGULACIÓN DE LAS ACTIVIDADES DE ORGANISMOS QUE PRESTAN SERVICIOS SANITARIOS, EDUCATIVOS, CULTURALES', '841300, REGULACIÓN Y FACILITACIÓN DE LA ACTIVIDAD ECONÓMICA']
}, {
  nombre: 'PRESTACIÓN DE SERVICIOS A LA COMUNIDAD EN GENERAL',
  giros: ['842100, RELACIONES EXTERIORES', '842200, ACTIVIDADES DE DEFENSA', '842300, ACTIVIDADES DE MANTENIMIENTO DEL ORDEN PÚBLICO Y DE SEGURIDAD']
}, {
  nombre: 'ACTIVIDADES DE PLANES DE SEGURIDAD SOCIAL DE AFILIACIÓN OBLIGATORIA',
  giros: ['843010, FONDO NACIONAL DE SALUD (FONASA)', '843020, INSTITUTO DE PREVISIÓN SOCIAL (IPS)', '843090, OTROS PLANES DE SEGURIDAD SOCIAL DE AFILIACIÓN OBLIGATORIA N.C.P.']
}, {
  nombre: 'ENSEÑANZA PREESCOLAR',
  giros: ['850011, ENSEÑANZA PREESCOLAR PÚBLICA', '850012, ENSEÑANZA PRIMARIA, SECUNDARIA CIENTÍFICO HUMANISTA Y TÉCNICO PROFESIONAL PÚBLICA', '850021, ENSEÑANZA PREESCOLAR PRIVADA', '850022, ENSEÑANZA PRIMARIA, SECUNDARIA CIENTÍFICO HUMANISTA Y TÉCNICO PROFESIONAL PRIVADA']
}, {
  nombre: 'ENSEÑANZA SUPERIOR',
  giros: ['853110, ENSEÑANZA SUPERIOR EN UNIVERSIDADES PÚBLICAS', '853120, ENSEÑANZA SUPERIOR EN UNIVERSIDADES PRIVADAS', '853201, ENSEÑANZA SUPERIOR EN INSTITUTOS PROFESIONALES', '853202, ENSEÑANZA SUPERIOR EN CENTROS DE FORMACIÓN TÉCNICA']
}, {
  nombre: 'OTROS TIPOS DE ENSEÑANZA',
  giros: ['854100, ENSEÑANZA DEPORTIVA Y RECREATIVA', '854200, ENSEÑANZA CULTURAL', '854901, ENSEÑANZA PREUNIVERSITARIA', '854902, SERVICIOS PERSONALES DE EDUCACIÓN', '854909, OTROS TIPOS DE ENSEÑANZA N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE APOYO A LA ENSEÑANZA',
  giros: ['855000, ACTIVIDADES DE APOYO A LA ENSEÑANZA']
}, {
  nombre: 'ACTIVIDADES DE HOSPITALES PÚBLICOS Y PRIVADOS',
  giros: ['861010, ACTIVIDADES DE HOSPITALES Y CLÍNICAS PÚBLICAS', '861020, ACTIVIDADES DE HOSPITALES Y CLÍNICAS PRIVADAS']
}, {
  nombre: 'ACTIVIDADES DE MÉDICOS Y ODONTÓLOGOS',
  giros: ['862010, ACTIVIDADES DE CENTROS DE SALUD MUNICIPALIZADOS (SERVICIOS DE SALUD PÚBLICA)', '862021, CENTROS MÉDICOS PRIVADOS (ESTABLECIMIENTOS DE ATENCIÓN AMBULATORIA)', '862022, CENTROS DE ATENCIÓN ODONTOLÓGICA PRIVADOS (ESTABLECIMIENTOS DE ATENCIÓN AMBULATORIA)', '862031, SERVICIOS DE MÉDICOS PRESTADOS DE FORMA INDEPENDIENTE', '862032, SERVICIOS DE ODONTÓLOGOS PRESTADOS DE FORMA INDEPENDIENTE']
}, {
  nombre: 'OTRAS ACTIVIDADES DE ATENCIÓN DE LA SALUD HUMANA',
  giros: ['869010, ACTIVIDADES DE LABORATORIOS CLÍNICOS Y BANCOS DE SANGRE', '869091, OTROS SERVICIOS DE ATENCIÓN DE LA SALUD HUMANA PRESTADOS POR EMPRESAS', '869092, SERVICIOS PRESTADOS DE FORMA INDEPENDIENTE POR OTROS PROFESIONALES DE LA SALUD']
}, {
  nombre: 'ACTIVIDADES DE ATENCIÓN DE ENFERMERÍA EN INSTITUCIONES',
  giros: ['871000, ACTIVIDADES DE ATENCIÓN DE ENFERMERÍA EN INSTITUCIONES']
}, {
  nombre: 'ACTIVIDADES DE ATENCIÓN EN INSTITUCIONES PARA PERSONAS CON DISCAPACIDAD MENTAL Y TOXICÓMANOS',
  giros: ['872000, ACTIVIDADES DE ATENCIÓN EN INSTITUCIONES PARA PERSONAS CON DISCAPACIDAD MENTAL Y TOXICÓMANOS']
}, {
  nombre: 'ACTIVIDADES DE ATENCIÓN EN INSTITUCIONES PARA PERSONAS DE EDAD Y PERSONAS CON DISCAPACIDAD',
  giros: ['873000, ACTIVIDADES DE ATENCIÓN EN INSTITUCIONES PARA PERSONAS DE EDAD Y PERSONAS CON DISCAPACIDAD FÍSICA']
}, {
  nombre: 'OTRAS ACTIVIDADES DE ATENCIÓN EN INSTITUCIONES',
  giros: ['879000, OTRAS ACTIVIDADES DE ATENCIÓN EN INSTITUCIONES']
}, {
  nombre: 'ACTIVIDADES DE ASISTENCIA SOCIAL SIN ALOJAMIENTO PARA PERSONAS DE EDAD Y PERSONAS CON DISCAPACIDAD',
  giros: ['881000, ACTIVIDADES DE ASISTENCIA SOCIAL SIN ALOJAMIENTO PARA PERSONAS DE EDAD Y PERSONAS CON DISCAPACIDAD']
}, {
  nombre: 'OTRAS ACTIVIDADES DE ASISTENCIA SOCIAL SIN ALOJAMIENTO',
  giros: ['889000, OTRAS ACTIVIDADES DE ASISTENCIA SOCIAL SIN ALOJAMIENTO']
}, {
  nombre: 'ACTIVIDADES CREATIVAS',
  giros: ['900001, SERVICIOS DE PRODUCCIÓN DE OBRAS DE TEATRO, CONCIERTOS, ESPECTÁCULOS DE DANZA, OTRAS PROD. ESCÉNICAS', '900002, ACTIVIDADES ARTÍSTICAS REALIZADAS POR BANDAS DE MÚSICA, COMPAÑÍAS DE TEATRO, CIRCENSES Y SIMILARES', '900003, ACTIVIDADES DE ARTISTAS REALIZADAS DE FORMA INDEPENDIENTE: ACTORES, MÚSICOS, ESCRITORES, ENTRE OTROS', '900004, SERVICIOS PRESTADOS POR PERIODISTAS INDEPENDIENTES', '900009, OTRAS ACTIVIDADES CREATIVAS, ARTÍSTICAS Y DE ENTRETENIMIENTO N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE BIBLIOTECAS',
  giros: ['910100, ACTIVIDADES DE BIBLIOTECAS Y ARCHIVOS', '910200, ACTIVIDADES DE MUSEOS, GESTIÓN DE LUGARES Y EDIFICIOS HISTÓRICOS', '910300, ACTIVIDADES DE JARDINES BOTÁNICOS, ZOOLÓGICOS Y RESERVAS NATURALES']
}, {
  nombre: 'ACTIVIDADES DE JUEGOS DE AZAR Y APUESTAS',
  giros: ['920010, ACTIVIDADES DE CASINOS DE JUEGOS', '920090, OTRAS ACTIVIDADES DE JUEGOS DE AZAR Y APUESTAS N.C.P.']
}, {
  nombre: 'ACTIVIDADES DEPORTIVAS',
  giros: ['931101, HIPÓDROMOS', '931102, GESTIÓN DE SALAS DE BILLAR; GESTIÓN DE SALAS DE BOLOS (BOWLING)', '931109, GESTIÓN DE OTRAS INSTALACIONES DEPORTIVAS N.C.P.', '931201, ACTIVIDADES DE CLUBES DE FÚTBOL AMATEUR Y PROFESIONAL', '931209, ACTIVIDADES DE OTROS CLUBES DEPORTIVOS N.C.P.', '931901, PROMOCIÓN Y ORGANIZACIÓN DE COMPETENCIAS DEPORTIVAS', '931909, OTRAS ACTIVIDADES DEPORTIVAS N.C.P.']
}, {
  nombre: 'OTRAS ACTIVIDADES DE ESPARCIMIENTO Y RECREATIVAS',
  giros: ['932100, ACTIVIDADES DE PARQUES DE ATRACCIONES Y PARQUES TEMÁTICOS', '932901, GESTIÓN DE SALAS DE POOL; GESTIÓN (EXPLOTACIÓN) DE JUEGOS ELECTRÓNICOS', '932909, OTRAS ACTIVIDADES DE ESPARCIMIENTO Y RECREATIVAS N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE ASOCIACIONES EMPRESARIALES',
  giros: ['941100, ACTIVIDADES DE ASOCIACIONES EMPRESARIALES Y DE EMPLEADORES', '941200, ACTIVIDADES DE ASOCIACIONES PROFESIONALES']
}, {
  nombre: 'ACTIVIDADES DE SINDICATOS',
  giros: ['942000, ACTIVIDADES DE SINDICATOS']
}, {
  nombre: 'ACTIVIDADES DE OTRAS ASOCIACIONES',
  giros: ['949100, ACTIVIDADES DE ORGANIZACIONES RELIGIOSAS', '949200, ACTIVIDADES DE ORGANIZACIONES POLÍTICAS', '949901, ACTIVIDADES DE CENTROS DE MADRES', '949902, ACTIVIDADES DE CLUBES SOCIALES', '949903, FUNDACIONES Y CORPORACIONES; ASOCIACIONES QUE PROMUEVEN ACTIVIDADES CULTURALES O RECREATIVAS', '949904, CONSEJO DE ADMINISTRACIÓN DE EDIFICIOS Y CONDOMINIOS', '949909, ACTIVIDADES DE OTRAS ASOCIACIONES N.C.P.']
}, {
  nombre: 'REPARACIÓN DE COMPUTADORES Y EQUIPO DE COMUNICACIONES',
  giros: ['951100, REPARACIÓN DE COMPUTADORES Y EQUIPO PERIFÉRICO', '951200, REPARACIÓN DE EQUIPO DE COMUNICACIONES (INCLUYE LA REPARACIÓN TELÉFONOS CELULARES)']
}, {
  nombre: 'REPARACIÓN DE EFECTOS PERSONALES Y ENSERES DOMÉSTICOS',
  giros: ['952100, REPARACIÓN DE APARATOS ELECTRÓNICOS DE CONSUMO (INCLUYE APARATOS DE TELEVISIÓN Y RADIO)', '952200, REPARACIÓN DE APARATOS DE USO DOMÉSTICO, EQUIPO DOMÉSTICO Y DE JARDINERÍA', '952300, REPARACIÓN DE CALZADO Y DE ARTÍCULOS DE CUERO', '952400, REPARACIÓN DE MUEBLES Y ACCESORIOS DOMÉSTICOS', '952900, REPARACIÓN DE OTROS EFECTOS PERSONALES Y ENSERES DOMÉSTICOS']
}, {
  nombre: 'OTRAS ACTIVIDADES DE SERVICIOS PERSONALES',
  giros: ['960100, LAVADO Y LIMPIEZA, INCLUIDA LA LIMPIEZA EN SECO, DE PRODUCTOS TEXTILES Y DE PIEL', '960200, PELUQUERÍA Y OTROS TRATAMIENTOS DE BELLEZA', '960310, SERVICIOS FUNERARIOS', '960320, SERVICIOS DE CEMENTERIOS', '960901, SERVICIOS DE ADIESTRAMIENTO, GUARDERÍA, PELUQUERÍA, PASEO DE MASCOTAS (EXCEPTO ACT. VETERINARIAS)', '960902, ACTIVIDADES DE SALONES DE MASAJES, BAÑOS TURCOS, SAUNAS, SERVICIO DE BAÑOS PÚBLICOS', '960909, OTRAS ACTIVIDADES DE SERVICIOS PERSONALES N.C.P.']
}, {
  nombre: 'ACTIVIDADES DE LOS HOGARES COMO EMPLEADORES DE PERSONAL DOMÉSTICO',
  giros: ['970000, ACTIVIDADES DE LOS HOGARES COMO EMPLEADORES DE PERSONAL DOMÉSTICO']
}
];